<template>
  <!-- 系统目录 西成药品 -->
  <div class="MedicenCata">
    <div class="dialog">

      <el-dialog
          title="医保结算详细信息"
          :visible.sync="ybSettlementDataDialogVisible"
          width="90%"
          :close-on-click-modal="false"
          :before-close="handleCancelYbData"
      >
        <!--        <el-tabs type="border-card">
                  <el-tab-pane label="医保预结算返回信息">-->
        <el-form label-width="250px" size="mini" disabled>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="就诊ID:">
                <el-input v-model="ybSettlementDataForm.mdtrt_id" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="人员编号:">
                <el-input v-model="ybSettlementDataForm.psn_no" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="人员姓名:">
                <el-input v-model="ybSettlementDataForm.psn_name" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="性别:">
                <el-select v-model="ybSettlementDataForm.gend">
                  <el-option v-for="item in gendOptions" :key="item.id" :label="item.label" :value="item.id">
                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="证件类型:">
                <el-select v-model="ybSettlementDataForm.psn_cert_type">
                  <el-option v-for="item in psnCertTypeOptions" :key="item.id" :label="item.label" :value="item.id">
                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="证件号码:">
                <el-input v-model="ybSettlementDataForm.certno" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="民族:">
                <el-select v-model="ybSettlementDataForm.naty">
                  <el-option v-for="item in natyOptions" :key="item.id" :label="item.label" :value="item.id">
                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出生日期:">
                <el-input v-model="ybSettlementDataForm.brdy" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="险种类型:">
                <el-select v-model="ybSettlementDataForm.insutype">
                  <el-option v-for="item in insutypeOptions" :key="item.id" :label="item.label" :value="item.id">
                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="人员类别:">
                <el-select v-model="ybSettlementDataForm.psn_type">
                  <el-option v-for="item in psnTypeOptions" :key="item.id" :label="item.label" :value="item.id">
                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="公务员标志:">
                <el-select v-model="ybSettlementDataForm.cvlserv_flag">
                  <el-option v-for="item in cvlservFlagOptions" :key="item.id" :label="item.label" :value="item.id">
                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结算时间:">
                <el-input v-model="ybSettlementDataForm.setl_time" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="就诊凭证类型:">
                <el-select v-model="ybSettlementDataForm.mdtrt_cert_type">
                  <el-option v-for="item in mdtrtCertTypeOptions" :key="item.id" :label="item.label" :value="item.id">
                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="医疗类别:">
                <el-select v-model="ybSettlementDataForm.med_type">
                  <el-option v-for="item in ybMedTypeOptions" :key="item.id" :label="item.label" :value="item.id">
                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="医疗费总额:">
                <el-input v-model="ybSettlementDataForm.medfee_sumamt" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="全自费金额:">
                <el-input v-model="ybSettlementDataForm.fulamt_ownpay_amt" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="超限价自费费用:">
                <el-input v-model="ybSettlementDataForm.overlmt_selfpay" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="先行自付金额:">
                <el-input v-model="ybSettlementDataForm.preselfpay_amt" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="符合政策范围金额:">
                <el-input v-model="ybSettlementDataForm.inscp_scp_amt" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="实际支付起付线:">
                <el-input v-model="ybSettlementDataForm.act_pay_dedc" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="基本医疗保险统筹基金支出:">
                <el-input v-model="ybSettlementDataForm.hifp_pay" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="基本医疗保险统筹基金支付比例:">
                <el-input v-model="ybSettlementDataForm.pool_prop_selfpay" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公务员医疗补助资金支出:">
                <el-input v-model="ybSettlementDataForm.cvlserv_pay" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="企业补充医疗保险基金支出:">
                <el-input v-model="ybSettlementDataForm.hifes_pay" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="居民大病保险资金支出:">
                <el-input v-model="ybSettlementDataForm.hifmi_pay" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职工大额医疗费用补助资金支出:">
                <el-input v-model="ybSettlementDataForm.hifob_pay" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="医疗救助基金支出:">
                <el-input v-model="ybSettlementDataForm.maf_pay" readonly></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="其他支出:">
                <el-input v-model="ybSettlementDataForm.oth_pay" readonly></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="基金支付总额:">
                <el-input v-model="ybSettlementDataForm.fund_pay_sumamt" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="个人负担总金额:">
                <el-input v-model="ybSettlementDataForm.psn_part_amt" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="个人账户支出:">
                <el-input v-model="ybSettlementDataForm.acct_pay" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="个人现金支出:">
                <el-input v-model="ybSettlementDataForm.psn_cash_pay" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="医院负担金额:">
                <el-input v-model="ybSettlementDataForm.hosp_part_amt" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="余额:">
                <el-input v-model="ybSettlementDataForm.balc" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="个人账户共济支付金额:">
                <el-input v-model="ybSettlementDataForm.acct_mulaid_pay" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="包干标准:">
                <el-input v-model="ybSettlementDataForm.exp_content.unif_pay_std" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="包干结余:">
                <el-input v-model="ybSettlementDataForm.exp_content.unif_pay_blnc" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="兜底保障金额:">
                <el-input v-model="ybSettlementDataForm.exp_content.bkst_safeg_amt" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="财政补助">
                <el-input v-model="ybSettlementDataForm.exp_content.fin_subs" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="照顾人员补助">
                <el-input v-model="ybSettlementDataForm.exp_content.care_subs" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="基本段统筹限额">
                <el-input v-model="ybSettlementDataForm.exp_content.bas_sec_pool_lmt" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="医药机构结算ID:">
                <el-input v-model="ybSettlementDataForm.medins_setl_id" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="清算经办机构:">
                <el-input v-model="ybSettlementDataForm.clr_optins" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="清算方式:">
                <el-input v-model="ybSettlementDataForm.clr_way" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="清算类别:">
                <el-select v-model="ybSettlementDataForm.clr_type">
                  <el-option v-for="item in clrTypeOptions" :key="item.id" :label="item.label" :value="item.id">
                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!--          </el-tab-pane>
                </el-tabs>-->


        <!--        <el-tabs type="border-card">
                  <el-tab-pane label="费用信息">
                    <el-form label-width="180px" size="mini">

                    </el-form>
                  </el-tab-pane>
                </el-tabs>


                <el-tabs type="border-card">

                  <el-tab-pane label="基金支付信息">
                    <el-form label-width="180px" size="mini">

                    </el-form>
                  </el-tab-pane>
                </el-tabs>

                <el-tabs type="border-card">

                  <el-tab-pane label="个人支付信息">
                    <el-form label-width="180px" size="mini">

                    </el-form>
                  </el-tab-pane>
                </el-tabs>

                <el-tabs type="border-card">

                  <el-tab-pane label="扩展信息">
                    <el-form label-width="180px" size="mini">

                    </el-form>
                  </el-tab-pane>
                </el-tabs>-->
        <span slot="footer" class="dialog-footer">
      <el-button @click="handleConfirmYbData" size="mini" type="primary">下一步</el-button>
      <el-button @click="handleCancelYbData" size="mini" type="warning">关 闭</el-button>
    </span>
      </el-dialog>

      <!--患者选择-->
      <el-dialog
          title="患者选择"
          :close-on-click-modal="false"
          :visible.sync="patientDialogVisible"
          width="70%"
          class="patient-dialog optimized-dialog"
      >
        <!-- 患者表格 -->
        <el-table
            :data="patientTableData"
            border
            highlight-current-row
            @current-change="handleClickRow"
            @row-dblclick="handleChoosePatient"
            style="width: 100%"
            height="500px"
        >
          <el-table-column v-for="(col, inx) in tableRows4" :key="inx" :type="col.type" :prop="col.prop"
                           :label="col.name" :render-header="labelHead" align="center"
                           :min-width="getColumnWidth(col.label,col.prop,patientTableData)">
            <template #default="{ row }">
              {{ safeGetMappedValue(col, row) }}
            </template>
          </el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button @click="patientDialogVisible = false" size="mini" class="cancel-btn">取消</el-button>
          <el-button type="primary" @click="handleChoosePatient" size="mini" :loading="loading" class="confirm-btn">
            确定
          </el-button>
        </div>

      </el-dialog>

      <!--待收费病人列表-->
      <el-dialog
          title="待收费病人列表"
          :close-on-click-modal="false"
          :visible.sync="awaitingPayDialogVisible"
          width="85%"
          class="patient-dialog optimized-dialog"
          :class="{'with-details': showAwaitingPayDetail}">

        <div class="table-main-container" :class="{'with-drawer': showAwaitingPayDetail}">
          <!-- 左侧主表格 -->
          <div class="table-left">
            <el-table
                :data="tableData4"
                border
                style="width: 100%; min-width: 1200px;"
                height="60vh"
                highlight-current-row
                show-summary
                :summary-method="getSummaries2"
                @current-change="getAwaitPayDetail"
                @row-dblclick="getOutPatientCharge"
            >
              <el-table-column fixed="left" label="行号" type="index" width="50px" align="center"></el-table-column>
              <el-table-column v-for="(col, inx) in tableRows5" :key="inx" :type="col.type" :prop="col.prop"
                               :label="col.name" :render-header="labelHead" align="center"
                               :min-width="getColumnWidth(col.label,col.prop,tableData4)">
                <template #default="{ row }">
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </el-table-column>
              <el-table-column
                  label="操作"
                  width="100"
                  align="center"
                  fixed="right"
              >
                <template #default="{ row }">
                  <el-button
                      type="primary"
                      size="mini"
                      @click.stop="getOutPatientCharge(row)"
                  >选择
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 右侧抽屉式表格 (收费明细) -->
          <div class="table-drawer" :class="{'open': showAwaitingPayDetail}">
            <div class="drawer-content">
              <el-table
                  ref="payDetailTable"
                  :data="tableData5"
                  border
                  show-summary
                  :summary-method="getSummaries2"
                  height="60vh"
                  class="custom-summary-table"
                  style="width: 100%">
                <el-table-column fixed="left" label="行号" type="index" width="50px" align="center"></el-table-column>
                <el-table-column v-for="(col, inx) in tableRows6" :key="inx" :type="col.type" :prop="col.prop"
                                 :label="col.name" align="center" :render-header="labelHead"
                                 :min-width="getColumnWidth(col.label,col.prop,tableData5)">
                  <template #default="{ row }">
                    {{ safeGetMappedValue(col, row) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-checkbox v-model="showAwaitingPayDetail" size="mini" style="margin-right: 20px;">显示收费明细
          </el-checkbox>
          <el-button @click="awaitingPayDialogVisible = false" size="mini" class="cancel-btn">取消</el-button>
        </div>
      </el-dialog>

      <!--快速建档-->
      <el-dialog
          title="快速建档-新增健康档案"
          :close-on-click-modal="false"
          :visible.sync="celerityFilingDialogVisible"
          width="50%"
          class="patient-dialog"
      >
        <el-form :model="celerityFilingForm" label-width="90px" size="mini" class="compact-form">
          <!-- 第一行：基本信息 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="姓名:">
                <el-input v-model="celerityFilingForm.name" size="mini"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别:">
                <el-select v-model="celerityFilingForm.sex" size="mini" style="width: 70px">
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="证件类型:">
                <el-select v-model="celerityFilingForm.identityCard" size="mini" style="width: 100%" filterable
                           clearable>
                  <el-option v-for="item in certypeOption" :key="item.id" :label="item.label"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行：证件号码和出生日期 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="证件号码:">
                <el-input
                    v-model="celerityFilingForm.certno"
                    style="width: 100%"
                    @blur="certnoMonitor(celerityFilingForm)"
                    @clear="patientForm.ageYear = null;patientForm.ageMonth = null;patientForm.brdy = '';"
                    clearable
                    maxlength="18"
                    show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出生日期:">
                <el-date-picker
                    v-model="celerityFilingForm.brdy"
                    type="date"
                    size="mini"
                    style="width: 100%"
                    :disabled="true"
                    :placeholder="patientForm.certno ? '' : '身份证自动计算'"
                    value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第三行：国家、民族、职业 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="国籍:">
                <el-select v-model="celerityFilingForm.ntlyId" size="mini" style="width: 100%" filterable clearable>
                  <el-option v-for="item in ntlyOptions" :key="item.id" :label="item.label"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="民族:">
                <el-select v-model="celerityFilingForm.naty" size="mini" style="width: 100%" filterable clearable>
                  <el-option v-for="item in nationOption" :key="item.id" :label="item.label"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职业:">
                <el-select v-model="celerityFilingForm.jobId" size="mini" style="width: 100%" filterable clearable>
                  <el-option v-for="item in profttlOption" :key="item.id" :label="item.label"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第四行：病员类型和合约单位 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="病员类型:">
                <el-select v-model="celerityFilingForm.prhType" size="mini" style="width: 100%">
                  <el-option v-for="item in this.prhTypeOption" :key="item.id" :label="item.label" :value="item.id">
                    <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合约单位:">
                <el-select
                    v-model="celerityFilingForm.contractUnit"
                    size="mini"
                    style="width: 100%"
                    filterable
                    clearable
                    @focus="getContuntList"
                >
                  <el-option v-for="item in contractUnitOption" :key="item.id" :label="item.label" :value="item.id">
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: right">
                <el-button size="mini" type="primary" plain @click.stop="handleEditContractUnit(item)"
                           style="margin-left: 10px">
                  保存
                </el-button>
                <el-tooltip content="若查询信息不对,可重新填写后点此按钮更改" placement="top" style="margin-left: 8px;">
                  <i class="el-icon-question" style="color: #909399; cursor: pointer;"></i>
                </el-tooltip>
              </span>
                  </el-option>
                  <el-option :value="undefined" disabled style="cursor: pointer">
                    <el-button type="text" @click="addUnitModalVisible = true">
                      <i class="el-icon-plus" style="font-weight: bold"></i> 新增合约单位
                    </el-button>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第五行：联系人信息 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="联系人:">
                <el-input v-model="celerityFilingForm.conerName" size="mini" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话:">
                <el-input v-model="celerityFilingForm.conerTel" size="mini" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人关系:">
                <el-select v-model="celerityFilingForm.conerRltsId" size="mini" style="width: 100%" filterable
                           clearable>
                  <el-option v-for="item in this.rltsEntitiesOption" :key="item.id" :label="item.label"
                             :value="item.id">
                    <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第六行：联系地址（单独一行） -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="联系地址:">
                <div class="address-container">
                  <el-select v-model="celerityFilingForm.province" @clear="handleClear(1)" size="mini"
                             style="width: 15%;" @focus="getArea()" filterable clearable>
                    <el-option v-for="item in this.provinces" :key="item.id" :label="item.label" :value="item.id">
                      <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                  <span class="address-unit">省</span>

                  <el-select v-model="celerityFilingForm.city" size="mini"
                             style="width: 15%;" @focus="getCity" @clear="handleClear(2)" filterable clearable
                             :disabled="celerityFilingForm.province===''">
                    <el-option v-for="item in this.cityOption" :key="item.id" :label="item.label" :value="item.id">
                      <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                  <span class="address-unit">市</span>

                  <el-select v-model="celerityFilingForm.county" size="mini" @clear="handleClear(3)" style="width: 15%;"
                             @focus="getCounty" filterable clearable :disabled="celerityFilingForm.city === ''">
                    <el-option v-for="item in this.countyOption" :key="item.id" :label="item.label" :value="item.id">
                      <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                  <span class="address-unit">县</span>

                  <el-select v-model="celerityFilingForm.town" size="mini" @clear="handleClear(4)" style="width: 15%;"
                             @focus="getTown" filterable clearable :disabled="celerityFilingForm.county === ''">
                    <el-option v-for="item in this.townOption" :key="item.id" :label="item.label" :value="item.id">
                      <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                  <span class="address-unit">镇</span>

                  <el-select v-model="celerityFilingForm.village" size="mini" @clear="handleClear(5)"
                             style="width: 20%;"
                             @focus="getVillage" filterable clearable :disabled="celerityFilingForm.town === ''">
                    <el-option v-for="item in this.villageOption" :key="item.id" :label="item.label" :value="item.id">
                      <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                  <span class="address-unit">乡</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="celerityFilingDialogVisible = false" size="mini">取消</el-button>
          <el-button type="primary" @click="handleAddCelerityFiling" size="mini" :loading="loading">保存</el-button>
        </div>
      </el-dialog>

      <!--结算-->
      <el-dialog
          title="门诊支付窗口"
          :close-on-click-modal="false"
          :visible.sync="settleAccountsDialogVisible"
          width="800px"
          class="payment-dialog"
      >
        <el-form :model="paymentForm" label-width="100px" class="payment-form">
          <div class="form-section">
            <div class="wallet-balance" style="margin-bottom: 15px; padding: 10px; background: #f0f9eb; border-radius: 4px;">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div style="font-size: 12px; color: #67C23A;">当前充值余额：{{ currentRecahrgeAmt }} 元</div>
                </el-col>
                <el-col :span="12">
                  <div style="font-size: 12px; color: #E6A23C;">当前赠送余额：{{ currentHandselAmt }} 元</div>
                </el-col>
              </el-row>
            </div>
            <!-- 动态生成支付方式 -->
            <template v-if="dynamicPaymentMethods.length > 0">
              <el-row
                  v-for="(row, index) in dynamicPaymentRows"
                  :key="index"
                  :gutter="20"
                  class="payment-row"
              >
                <el-col
                    v-for="method in row"
                    :key="method.id"
                    :span="8"
                >
                  <el-form-item
                      :label="method.wayName + ':'"
                      class="payment-item"
                  >
                    <div style="display: flex; gap: 5px;">
                      <el-input
                          v-model.number="dynamicPaymentValues[method.id]"
                          type="number"
                          step="0.01"
                          size="mini"
                          @change="calculateDynamicPayments"
                          style="flex: 1;"
                      >
                        <template slot="suffix">
                          <span class="assign-btn" @click.stop="handleAssignPayment(method.id)">分配</span>
                        </template>
                      </el-input>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <div v-else style="text-align: center; padding: 20px; color: #999;">
              正在加载支付方式...
            </div>

            <!-- 结算信息 -->
            <div class="payment-summary">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="应付金额:" class="compact-item">
                    <span class="amount">{{ outpatientChargesForm.currentTotal }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="已支付:" class="compact-item">
                    <span class="amount">{{ totalPaid.toFixed(2) }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="还需支付:" class="compact-item">
        <span class="amount" :style="{ color: remainingToPay > 0 ? '#f56c6c' : '#67c23a' }">
          {{ remainingToPay.toFixed(2) }}
        </span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="找零:" class="compact-item">
                    <span class="amount">{{ changeAmount.toFixed(2) }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 按钮组 -->
          <div class="form-actions">
            <!--            <el-button type="text">查看优惠明细</el-button>
                        <el-button>打印发票</el-button>-->
            <el-button type="primary" @click="handleConfirmCharge" :loading="chargeLoading">确认支付</el-button>
            <el-button type="warning" @click="handleClosePayment">退出支付</el-button>
          </div>
        </el-form>
      </el-dialog>

      <!--选择挂账类型-->
      <el-dialog
          title="请选择挂账类型"
          :close-on-click-modal="false"
          :visible.sync="onCreditDialogVisible"
          width="30%"
      >
        <!-- 下拉框 -->
        <el-select
            v-model="paymentForm.bebtId"
            placeholder="请选择选项"
            style="width: 100%"
            size="mini"
        >
          <el-option v-for="item in onCreditOption" :key="item.id" :label="item.label" :value="item.id">
            <span style="float: left">{{ item.label }}</span>
            <span style="float: right" v-if="$store.getters.hasPermission('system:bebttype:edit')">
              <el-button size="mini" type="primary" plain @click.stop="handleOpenEditOnCredit(item)"
                         style="margin-left: 10px">
                修改
              </el-button>
              </span>
          </el-option>
          <el-option :value="undefined" disabled style="cursor: pointer"
                     v-if="$store.getters.hasPermission('system:bebttype:add')"><!--system:bebttype:add-->
            <el-button type="text" @click="handleOpenAddOnCredit"><i class="el-icon-plus"
                                                                     style="font-weight: bold"></i> 新增挂账类型
            </el-button>
          </el-option>
        </el-select>

        <!-- 底部按钮 -->
        <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="handleCloseOnCredit" size="mini">取消</el-button>
        <el-button type="primary" @click="handleConfirmPayment2" size="mini">确认</el-button>
      </span>
      </el-dialog>


      <el-dialog :title="addUnitForm.id  == null ?'新增合约单位':'修改合约单位'" :before-close="handleCancelAddUnit"
                 :visible.sync="addUnitModalVisible" class="addUnitDialog" width="50%" :close-on-click-modal="false">
        <div class="aform">
          <!-- 表单 -->
          <el-form :model="addForm" label-width="90px" size="mini" :rules="addUnitRules" ref="addUnitRef">
            <el-row :gutter="20">
              <el-col :span="v.spanRows" type="flex" v-for="(v,i) in addUnitType" :key="i"
                      :style="{ marginLeft: v.modelValue === 'uscc' ? '18px' : '0' }">
                <!-- input -->
                <el-form-item v-if="v.type === 'input'" :required="['code', 'name'].includes(v.modelValue)"
                              :label="v.label" :style="v.modelValue === 'uscc' ? 'white-space: nowrap' : ''">
                  <el-input :suffix-icon='v.prefix' v-model="$data.addUnitForm[v.modelValue]"
                            @input="handleNameChangeCode(v,i)" :disabled="v.modelValue === 'code' ? true : null"
                            :style="{ marginLeft: v.modelValue === 'uscc' ? '30px' : '0' }">

                  </el-input>
                </el-form-item>
                <!-- select -->
                <el-form-item v-if="v.type === 'select'" :label="v.label">
                  <el-select v-model="$data.addUnitForm[v.modelValue]" filterable
                             :disabled="v.modelValue === 'untAtte'">
                    <el-option v-for="item in $data[v.op]" :key="item.id" :label="item.label" :value="item.id">
                      <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 新增的按钮区域 - 并排显示（添加在前，取消在后） -->
            <el-form-item style="margin-top: 20px; text-align: right">
              <el-button type="primary" size="mini" @click="handleAddContractUnit">
                {{ addUnitForm.id == null ? '新增' : '修改' }}
              </el-button>
              <el-button size="mini" @click="handleCancelAddUnit" style="margin-left: 10px">取消</el-button>
            </el-form-item>
          </el-form>
        </div>

      </el-dialog>
      <!--新增修改挂账类型-->
      <el-dialog
          :title='addOnCreditForm.id == null ? "新增挂账类型" : "修改挂账类型"'
          :close-on-click-modal="false"
          :visible.sync="addOnCreditDialogVisible"
          width="700px"
          @close="handleCloseAddOnCredit"
          class="custom-form-dialog"
      >
        <el-form
            size="mini"
            :model="addOnCreditForm"
            ref="addOnCreditForm"
            :rules="addOnCreditFormRules"
            label-width="110px"
            label-position="right"
        >
          <!-- 第一行：编码 + 合约单位 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="编码：" prop="code">
                <el-input
                    v-model="addOnCreditForm.code"
                    placeholder="如：HT20230001"
                    clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合约单位：" prop="cotUnit">
                <el-select
                    v-model="addOnCreditForm.cotUnit"
                    placeholder="请选择"
                    style="width: 100%"
                    clearable
                >
                  <el-option :value="undefined" disabled style="cursor: pointer">
                    <el-button type="text" @click="handleSaveContractUnit" style="padding: 0;">
                      <i class="el-icon-plus" style="font-weight: bold"></i> 新增合约单位
                    </el-button>
                  </el-option>
                  <el-option v-for="item in contractUnitOption" :key="item.id" :label="item.label"
                             :value="item.id">
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: right">
                    <el-button size="mini" type="primary" plain @click.stop="handleEditContractUnit(item)"
                               style="margin-left: 6px; padding: 4px;">修改</el-button>
                  </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行：名称 + 状态 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="名称：" prop="name">
                <el-input
                    v-model="addOnCreditForm.name"
                    @input="handleOnCreditNameGetPy"
                    placeholder="请输入完整名称"
                    clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态：" prop="state">
                <el-select
                    v-model="addOnCreditForm.state"
                    placeholder="请选择状态"
                    style="width: 100%"
                >
                  <el-option
                      v-for="item in stateOption"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第三行：开始时间 + 结束时间 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="开始时间：" prop="beginTime">
                <el-date-picker
                    v-model="addOnCreditForm.beginTime"
                    type="datetime"
                    placeholder="选择开始时间"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="'00:00:00'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间：" prop="endTime">
                <el-date-picker
                    v-model="addOnCreditForm.endTime"
                    type="datetime"
                    placeholder="选择结束时间"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="'23:59:59'"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 拼音简码（单独一行） -->
          <el-form-item label="拼音简码：">
            <el-input
                v-model="addOnCreditForm.pycode"
                placeholder="自动生成"
                disabled
                class="disabled-input"
            />
          </el-form-item>


          <!-- 备注（文本域） -->
          <el-form-item label="备注：">
            <el-input
                type="textarea"
                v-model="addOnCreditForm.remarks"
                :rows="3"
                placeholder="可输入额外说明信息"
                resize="none"
                show-word-limit
                maxlength="200"
            />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCloseAddOnCredit" size="mini">取消</el-button>
          <el-button type="primary" @click="handleAddOnCredit" size="mini">保存</el-button>
        </div>
      </el-dialog>

      <!--新增修改合约单位-->
      <el-dialog :title="addUnitForm.id  == null ?'新增合约单位':'修改合约单位'" :before-close="handleCancelContract"
                 :visible.sync="addUnitModalVisible" class="addUnitDialog" width="50%" :close-on-click-modal="false">
        <div class="aform">
          <!-- 表单 -->
          <el-form label-width="90px" size="mini" :rules="addUnitRules" ref="addUnitRef">
            <el-row :gutter="20">
              <el-col :span="v.spanRows" type="flex" v-for="(v,i) in addUnitType" :key="i"
                      :style="{ marginLeft: v.modelValue === 'uscc' ? '18px' : '0' }">
                <!-- input -->
                <el-form-item v-if="v.type === 'input'" :required="['code', 'name'].includes(v.modelValue)"
                              :label="v.label" :style="v.modelValue === 'uscc' ? 'white-space: nowrap' : ''">
                  <el-input :suffix-icon='v.prefix' v-model="$data.addUnitForm[v.modelValue]"
                            @input="handleNameChangeCode(v,i)"
                            :disabled="v.modelValue === 'code' ? true : null"
                            :style="{ marginLeft: v.modelValue === 'uscc' ? '30px' : '0' }">

                  </el-input>
                </el-form-item>
                <!-- select -->
                <el-form-item v-if="v.type === 'select'" :label="v.label">
                  <el-select v-model="$data.addUnitForm[v.modelValue]" filterable
                             :disabled="v.modelValue === 'untAtte'">
                    <el-option v-for="item in $data[v.op]" :key="item.id" :label="item.label" :value="item.id">
                      <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 新增的按钮区域 - 并排显示（添加在前，取消在后） -->
            <el-form-item style="margin-top: 20px; text-align: right">
              <el-button type="primary" size="mini" @click="handleAddContractUnit">
                {{ addUnitForm.id == null ? '新增' : '修改' }}
              </el-button>
              <el-button size="mini" @click="handleCancelContract" style="margin-left: 10px">取消</el-button>
            </el-form-item>
          </el-form>
        </div>

      </el-dialog>

      <!--付款码支付窗口-->
      <el-dialog
          title="请扫描患者付款码"
          :visible.sync="payModalVisible"
          width="30%"
          :close-on-click-modal="false"
          @opened="handlePayDialogOpened"
          @closed="handlePayDialogClosed">

        <!-- 隐藏的扫码输入框 -->
        <div style="position: absolute; left: -9999px;">
          <el-input
              ref="paymentCodeInput"
              v-model="paymentCode"
              @input="handleScanComplete">
          </el-input>
        </div>

        <!-- 可视化提示区域 -->
        <div style="text-align: center; padding: 20px 0;">
          <!-- 状态1：等待扫码 -->
          <template v-if="scanStatus === 'waiting'">
            <i class="el-icon-loading" style="font-size: 40px;"></i>
            <p style="margin-top: 15px;">请使用扫码枪扫描顾客付款码</p>
          </template>

          <!-- 状态2：处理中 -->
          <template v-else-if="scanStatus === 'processing'">
            <i class="el-icon-loading" style="font-size: 40px;"></i>
            <p style="margin-top: 15px;">正在处理付款请求...</p>
          </template>

          <!-- 状态3：处理成功 -->
          <template v-else-if="scanStatus === 'success'">
            <i class="el-icon-success" style="font-size: 40px; color: #67C23A;"></i>
            <p style="margin-top: 15px;">
              付款成功！{{ countdown }}秒后自动关闭
            </p>
            <el-progress
                :percentage="countdown * 20"
                status="success"
                style="width: 80%; margin: 10px auto;"
            ></el-progress>
          </template>

          <template v-else-if="scanStatus === 'error'">
            <i class="el-icon-error" style="font-size: 40px; color: #F56C6C;"></i>
            <p style="margin-top: 15px;">{{ errorMessage }}</p>
            <p style="margin-top: 10px; color: #999;">{{ countdown }}秒后重新开始扫码</p>
            <el-progress
                :percentage="countdown * 20"
                status="exception"
                style="width: 80%; margin: 10px auto;"
            ></el-progress>
          </template>
        </div>
      </el-dialog>

      <!--结班-->
      <el-dialog
          :close-on-click-modal="false"
          title="结班"
          :visible.sync="finalReportDialogVisible"
          width="70%"
          :top="'50px'"
          @close="handleCloseFinalReport">
        <el-form
            :model="finalReportShowFrom"
            size="mini"
            label-width="100px">
          <el-row :gutter="20">  <!-- 增加 gutter 提供间隔 -->
            <el-col :span="6">  <!-- 缩小机构字段宽度 -->
              <el-form-item label="机构:">
                <el-input v-model="finalReportShowFrom.clinicName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结班人:">
                <el-input v-model="finalReportShowFrom.staffName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="时间:">
                <div style="display: flex; align-items: center;">
                  <!-- 开始时间（禁用） -->
                  <el-date-picker
                      v-model="finalReportShowFrom.timeRange[0]"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      style="width: 180px;">
                  </el-date-picker>
                  <span style="margin: 0 10px;">-</span>
                  <!-- 结束时间（可编辑） -->
                  <el-date-picker
                      v-model="finalReportShowFrom.timeRange[1]"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      style="width: 180px;">
                  </el-date-picker>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" size="mini" style="margin-top: 2px;"
                         @click="handleQueryFeeAndRegAndSettleAccountsData">
                统计
              </el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-tabs type="border-card" style="height: 100%" v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane label="结班信息" name="classInfo">
            <!-- 结班信息主表单 -->
            <el-form :model="settleAccountsForm" label-width="120px" size="mini" class="settle-form">

              <!-- 基本信息模块 -->
              <div class="form-section basic-section">
                <div class="section-title">基本信息</div>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="结班时间:">
                      <el-input v-model="settleAccountsForm.settleTime" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="总实收现金:">
                      <el-input v-model="settleAccountsForm.amount" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="总上交现金:">
                      <el-input v-model="settleAccountsForm.submitCash" readonly></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 挂号信息模块 -->
              <div class="form-section registration-section">
                <div class="section-title">挂号信息</div>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="挂号金额:">
                      <el-input v-model="settleAccountsForm.regAmount" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="挂号人次:">
                      <el-input v-model="settleAccountsForm.regNum" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="现金支付:">
                      <el-input v-model="settleAccountsForm.regCashAmt" readonly></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="网络支付:">
                      <el-input v-model="settleAccountsForm.regGroupAmt" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="挂号优惠:">
                      <el-input v-model="settleAccountsForm.regDiscount" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="退号人次:">
                      <el-input v-model="settleAccountsForm.regReturnNum" readonly></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 收费信息模块 -->
              <div class="form-section payment-section">
                <div class="section-title">收费信息</div>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="收费金额:">
                      <el-input v-model="settleAccountsForm.feeAmount" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="现金支付:">
                      <el-input v-model="settleAccountsForm.feeCashAmt" readonly></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item label="网络支付:">
                      <el-input v-model="settleAccountsForm.feeGroupAmt" readonly></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="社保支付:">
                      <el-input v-model="settleAccountsForm.socialSecurityPaymentCharge" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="挂账支付:">
                      <el-input v-model="settleAccountsForm.creditPayment" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="其他支付:">
                      <el-input v-model="settleAccountsForm.otherPaymentCharge" readonly></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 备注信息 -->
              <div class="form-section remark-section">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="备注:">
                      <el-input type="textarea" v-model="settleAccountsForm.remarks" :rows="3"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 操作按钮 -->
              <div class="form-actions">
                <el-button type="success" size="mini" @click="handleAddSettleAccounts">保存</el-button>
                <el-button type="warning" size="mini" @click='handleCancelSettleAccounts'>取消</el-button>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="收费信息" name="paymentInfo">
            <el-table :data="tableData7" border highlight-current-row>
              <el-table-column v-for="(col, inx) in tableRows8" :key="inx" :type="col.type" :prop="col.prop"
                               :label="col.name" :render-header="labelHead" align="center"
                               :min-width="getColumnWidth(col.label,col.prop,tableData7)">
                <template #default="{ row }">
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </el-table-column>
              <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleChargeListSizeChange"
                @current-change="handleChargeListCurrentChange"
                :current-page="pageNum"
                :page-sizes="[8, 16, 32]"
                :page-size="pageSize"
                :total="totalSize"
                layout="total, sizes, prev, pager, next, jumper"
                background>
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="挂号信息" name="registrationInfo">
            <el-table :data="tableData6" border highlight-current-row>
              <el-table-column v-for="(col, inx) in tableRows7" :key="inx" :type="col.type" :prop="col.prop"
                               :label="col.name" :render-header="labelHead" align="center"
                               :min-width="getColumnWidth(col.label,col.prop,tableData6)">
                <template #default="{ row }">
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </el-table-column>
              <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleRegistrationSizeChange"
                @current-change="handleRegistrationCurrentChange"
                :current-page="pageNum"
                :page-sizes="[8, 16, 32]"
                :page-size="pageSize"
                :total="totalSize"
                layout="total, sizes, prev, pager, next, jumper"
                background>
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>

      <el-dialog
          title="医保类别信息"
          :visible.sync="outpatientYbRegisterDialogVisible"
          width="20%"
          :before-close="handleOutpatientYbRegisterClose">

        <el-form
            :model="outpatientYbRegisterForm"
            :rules="outpatientYbRegisterFormRules"
            ref="outpatientForm"
            label-width="140px"
            size="mini">
          <el-row :gutter="20">
            <!-- 医疗类别 -->
            <el-col :span="24">
              <el-form-item label="医疗类别:" prop="med_type">
                <el-select v-model="outpatientYbRegisterForm.med_type">
                  <el-option
                      v-for="item in medTypeOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="疾病诊断:" prop="dise_codg">
                <el-select
                    v-model="outpatientYbRegisterForm.dise_codg"
                    filterable
                    remote
                    :remote-method="handleSearchWestDiagnose"
                    :loading="westDiagnoseLoading"
                    placeholder="请输入疾病名称搜索"
                    @change="handleGetWestDiagnose">
                  <el-option
                      v-for="item in westDiagnoseOptions"
                      :key="item.id"
                      :label="`${item.label}-(${item.code})`"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 个人结算方式 -->
            <el-col :span="24">
              <el-form-item label="个人结算方式:" prop="psnSetlway">
                <el-select v-model="outpatientYbRegisterForm.psnSetlway">
                  <el-option
                      v-for="item in psnSetlwayOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 个人账户使用标志 -->


            <el-col :span="24">
              <el-form-item label="就诊开始时间:" prop="begntime">
                <el-date-picker
                    v-model="outpatientYbRegisterForm.begntime"
                    type="datetime"
                    placeholder="选择就诊开始时间"
                    class="no-icon-datepicker"
                    style="width: 100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="个人账户使用标志:" prop="acct_used_flag">
                <el-select v-model="outpatientYbRegisterForm.acct_used_flag">
                  <el-option
                      v-for="item in acctUsedFlagOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>

        <span slot="footer">
        <el-button @click="handleOutpatientYbRegisterClose" size="mini">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleYBInfoUpload">确 定</el-button>
      </span>
      </el-dialog>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane label="患者信息">
        <!-- 添加标题栏和刷新按钮 -->
        <div slot="label" style="display: flex; align-items: center;">
          <span>患者信息</span>
          <el-button
              type="text"
              size="mini"
              icon="el-icon-refresh"
              @click="handleRefreshPatientInfo"
              style="margin-left: 5px; padding: 0;"
          >
            点此刷新
          </el-button>
        </div>

        <el-form :model="outpatientChargesForm" label-width="90px" size="mini" class="compact-form">
          <!-- 使用flex布局，自动换行 -->
          <div style="display: flex; flex-wrap: wrap; gap: 10px 20px; align-items: flex-start;">
            <!-- 每个表单项作为一个独立的flex item -->
            <div style="flex: 0 0 auto; min-width: 200px;">
              <el-form-item label="健康ID:">
                <el-input v-model="outpatientChargesForm.patId" size="mini"
                          @keyup.enter.native="handleSearchPatient" style="width: 120px">
                </el-input>
              </el-form-item>
            </div>
            <div style="flex: 0 0 auto; min-width: 200px;">
              <el-form-item label="姓名:">
                <el-input v-model="outpatientChargesForm.name" :disabled="true" size="mini" style="width: 120px"/>
              </el-form-item>
            </div>

            <div style="flex: 0 0 auto; min-width: 200px;">
              <el-form-item label="年龄:">
                <el-input v-model="outpatientChargesForm.age" :disabled="true" size="mini" style="width: 120px"/>
              </el-form-item>
            </div>

            <div style="flex: 0 0 auto; min-width: 220px;">
              <el-form-item label="开单医生:">
                <el-select size="mini" v-model="outpatientChargesForm.billingDoctor"
                           clearable :disabled="true" style="width: 140px">
                  <el-option v-for="item in userOptions" :key="item.id" :label="item.username"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div style="flex: 0 0 auto; min-width: 220px;">
              <el-form-item label="开单科室:">
                <el-select size="mini" v-model="outpatientChargesForm.billingDept"
                           clearable :disabled="true" style="width: 140px">
                  <el-option v-for="item in deptOptions" :key="item.id" :label="item.label"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div style="flex: 0 0 auto; min-width: 220px;">
              <el-form-item label="病人类型:">
                <el-select size="mini" v-model="outpatientChargesForm.patientType"
                           clearable disabled style="width: 140px">
                  <el-option v-for="item in prhTypeOption" :key="item.id" :label="item.label"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <!--    <div class="compact-form-box" style="height: 220px">

        </div>-->

    <el-tabs type="border-card">
      <el-tab-pane label="收费信息">
        <div class="medical-system-container">
          <!-- 1. 主表格区域 -->
          <div class="table-main-container" :class="{'with-drawer': showDetails}">
            <!-- 左侧主表格 -->
            <div class="table-main-container" :class="{'with-drawer': showAwaitingPayDetail}">
              <!-- 左侧主表格 - 待收费患者列表 -->
              <div class="table-left">
                <el-table
                    :data="tableData4"
                    border
                    height="100%"
                    @row-click="getAwaitPayDetail"
                    highlight-current-row>
                  <el-table-column fixed="left" label="行号" type="index" width="50px" align="center"></el-table-column>
                  <el-table-column v-for="(col, inx) in tableRows5" :key="inx" :type="col.type" :prop="col.prop"
                                   :label="col.name" :render-header="labelHead" align="center"
                                   :min-width="getColumnWidth(col.label,col.prop,tableData4)">
                    <template #default="{ row }">
                      {{ safeGetMappedValue(col, row) }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 右侧抽屉式表格 - 订单明细 -->
              <!-- 右侧抽屉式表格 - 订单明细 -->
              <div class="table-drawer" :class="{'open': showAwaitingPayDetail}">
                <div class="drawer-content">
                  <el-table
                      ref="tableData5"
                      :data="tableData5"
                      border
                      highlight-current-row
                      style="width: 100%;"
                      height="calc(100% - 56px)"
                      @row-dblclick="handleRowDblclick"
                      @selection-change="handleSelectedOrders">
                    <!-- ===== 新增多选框 ===== -->
                    <el-table-column type="selection" width="50" align="center"></el-table-column>
                    <!-- 行号 -->
                    <el-table-column fixed="left" label="行号" type="index" width="50px" align="center"></el-table-column>
                    <el-table-column
                        prop="orderNo"
                        label="订单号"
                        min-width="150"
                        align="center"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="patientName" label="患者姓名" width="100" align="center">
                      <template #default="{ row }">
                        {{ row.patientName || '-' }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="totalAmount" label="总金额" width="100" align="center">
                      <template #default="{ row }">
                        ¥{{ row.totalAmount || 0 }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="orderedAt" label="开单时间" min-width="160" align="center">
                      <template #default="{ row }">
                        {{ row.orderedAt }}
                      </template>
                    </el-table-column>
                    <!-- 展开行显示明细 -->
                    <el-table-column type="expand" label="明细" width="80" align="center">
                      <template #default="{ row }">
                        <el-table
                            :data="row.items || []"
                            border
                            size="mini"
                            style="width: 100%">
                          <el-table-column prop="itemName" label="项目名称" min-width="150" align="center">
                            <template #default="{ row }">
                              {{ row.itemName || '-' }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="specification" label="规格" min-width="120" align="center">
                            <template #default="{ row }">
                              {{ row.specification || '-' }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="itemType" label="项目类型" width="80" align="center">
                            <template #default="{ row }">
                              {{ getItemTypeText(row.itemType) }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="quantity" label="数量" width="70" align="center">
                            <template #default="{ row }">
                              {{ row.quantity || 0 }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="unitName" label="单位" width="70" align="center">
                            <template #default="{ row }">
                              {{ row.unitName || '-' }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="unitPrice" label="单价" width="80" align="center">
                            <template #default="{ row }">
                              ¥{{ row.unitPrice || 0 }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="totalAmount" label="金额" width="90" align="center">
                            <template #default="{ row }">
                              ¥{{ row.totalAmount || 0 }}
                            </template>
                          </el-table-column>
                        </el-table>
                      </template>
                    </el-table-column>
                  </el-table>

                  <!-- ===== 底部汇总栏 ===== -->
                  <div class="selected-summary">
                    <span>已选 <span style="color: #409EFF; font-weight: 600;">{{ selectedOrderIds.length }}</span> 个订单</span>
                    <span style="margin-left: 20px;">合计：<span style="color: #F56C6C; font-weight: 600; font-size: 16px;">¥{{ getSelectedTotalAmount() }}</span></span>
                  </div>
                </div>
              </div>            </div>
          </div>

          <!-- 2. 底部控制表单（严格保持在底部） -->
          <el-form :model="patientForm" label-width="90px" size="mini">
            <div class="form-grid">
              <div class="form-main">
                <!-- 使用flex布局自动换行 -->
                <div class="flex-form-row">
                  <el-form-item label="本次合计:" class="form-item-flex">
                    <el-input disabled v-model="outpatientChargesForm.thisTimeTotal" style="width: 100px"/>
                  </el-form-item>

                  <el-form-item label="折后合计:" class="form-item-flex">
                    <el-input v-model="outpatientChargesForm.discountedTotal" :disabled="true" style="width: 100px"/>
                  </el-form-item>

                  <el-form-item label="上一健康ID:" class="form-item-flex">
                    <el-input v-model="outpatientChargesForm.BeforePatId" :disabled="true" style="width: 100px"/>
                  </el-form-item>

                  <el-form-item label="上笔金额:" class="form-item-flex">
                    <el-input v-model="outpatientChargesForm.BeforePaidAmt" :disabled="true" style="width: 100px"/>
                  </el-form-item>

                  <el-form-item label="上笔收到:" class="form-item-flex">
                    <el-input v-model="outpatientChargesForm.BeforeReceiveAmt" :disabled="true" style="width: 100px"/>
                  </el-form-item>

                  <el-form-item label="上笔找零:" class="form-item-flex">
                    <el-input v-model="outpatientChargesForm.BeforeChange" :disabled="true" style="width: 100px"/>
                  </el-form-item>

                  <el-form-item label="显示明细:" label-width="80px" class="form-item-flex">
                    <el-checkbox v-model="showDetails"/>
                  </el-form-item>
                </div>

                <div class="button-group">
                  <div class="primary-actions">
                    <el-button type="primary" size="mini" @click="handleOpenFinalReport">结班</el-button>
                  </div>
                  <div class="action-buttons">
                    <el-dropdown @command="handleYbSwipingCardOrHumanFace" trigger="click"
                                 v-if="this.userInfo?.isInsurance === '1'">
                      <el-button type="primary" size="small">
                        医保<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown" class="yb-dropdown-menu">
                        <el-dropdown-item command="face">
                          <el-radio label="1">人脸识别</el-radio>
                        </el-dropdown-item>
                        <el-dropdown-item command="electronic">
                          <el-radio label="2">电子医保</el-radio>
                        </el-dropdown-item>
                        <el-dropdown-item command="YbCard">
                          <el-radio label="3">医保刷卡</el-radio>
                        </el-dropdown-item>
                        <el-dropdown-item command="identityCard" :disabled="this.outpatientChargesForm.certno === ''">
                          <el-radio label="4" :disabled="this.outpatientChargesForm.certno === ''">身份证认证</el-radio>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="success" size="mini" @click="handleSettleAccounts">结算</el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import {
  addContractUnit,
  addDocphr,
  dict,
  editContractUnit,
  getArea,
  getContractUnit,
  getContuntList,
  getDeptList, getDocphrClinicList,
  getDocphrList,
  getDoctorList
} from "@/api/reservation/reservation";
import AddType from './reservationAddType.js'
import {pinyin} from "pinyin-pro";
import {getChargingPrice} from "@/api/cosrute/Cosrute";
import {
  addConfirmPayment,
  addOnCredit,
  addSettleAccounts,
  addYbOutpatientSettleAccounts,
  editOnCredit,
  getChargelist,
  getChinaDetail,
  getFeeList,
  getLastSettleAccountsTime,
  getOnCreditById,
  getOnCreditList,
  getRegisterList,
  getSqbPaymentState,
  getWestDetail,
  getYbOutpatientSettleAccounts,
  sqbPayment,
  updateYbOutpatientSettleAccounts
} from "@/api/reservation/outpatientCharge";
import {
  getDocticdList, getDoctordisposeById,
  getDrugUnt,
  getMedicationFrequency,
  getReceptionDiagnosis
} from "@/api/reservation/outpatientPhysician";
import {getDosaUnt} from "@/api/MedicenCata";
import {MessageBox} from 'element-ui';
import {readIdCard} from "@/untils/idCardReader";
import {withLoading} from "@/untils/loading";
import dayjs from "dayjs";
import {getAllReservation, getRegisterType} from "@/api/reservation/reservationList";
import {getChargeList} from "@/api/reservation/outpatientChargeList";
import {selectDrugDosageForm} from "@/api/systemCatalogue/Dosage";
import {getCategory} from "@/api/Outpatient/category";
import {getSystemList} from "@/api/systemParameter/systemParameter";
import ybOutpatientMedical from '@/untils/ybOutpatientMedical';
import {buildYbRequest} from "@/api/yb/ybApi";
import {addYbResponseData, addYbRquestData} from "@/api/yb";
import {handleYB_1101_Upload, handleYB_Business_Upload} from "@/api/yb/ocxActiveXApi";
import {getFinanceclassList} from "@/api/clasificacionContable/clasificacionContable";
import {getPatternPaymentList} from "@/api/patternPayment/patternPayment";
import {getAmtById} from "@/api/patientRechargeStatistics/patientRechargeStatistics";
import {
  fullOrderCharge,
  getPatientsAwaitingPayment,
  getPatientsAwaitingPaymentByPatientId
} from "@/api/reservation/outpatientChargeV2";

export default {
  components: {},
  data() {
    return {
      chargeLoading:false,
      selectedOrderIds: [],
      selectedOrderData: [],
      totalChargeAmount: 0,
      currentRecahrgeAmt: '0.00',   // 充值余额
      currentHandselAmt: '0.00',    // 赠送余额
      dynamicPaymentMethods: [],  // 动态支付方式列表
      dynamicPaymentValues: {},   // 动态支付输入框的值
      settleAccountsForm: {
        endTime: '',
        feeIds: [],
        regIds: [],
        startTime: '',
        amount: null,
        feeAmount: null,
        feeCashAmt: null,
        feeGroupAmt: null,

        regAmount: null,
        regCashAmt: null,
        regGroupAmt: null,
        regNum: null,
        regReturnNum: null,

        settleTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),

        creditPayment: '',
        otherPaymentCharge: '',
        socialSecurityPaymentCharge: '',
        regDiscount: null,

        remarks: '',
      },
      pageNum: 1, //当前页currentPage
      pageSize: 8,
      totalSize: 10, //总条数
      //控制变量
      showDetails: false,//表格明细
      patientDialogVisible: false,//患者选择弹窗
      finalReportDialogVisible: false,//结班
      showAwaitingPayDetail: false,//待收费病人明细
      awaitingPayDialogVisible: false,//代收费病人列表
      loading: false,//加载圈
      celerityFilingDialogVisible: false,//快速建档弹窗
      ybSettlementDataDialogVisible: false,//医保结算弹窗
      settleAccountsDialogVisible: false,//门诊支付弹窗
      onCreditDialogVisible: false,//选择挂账类型弹窗
      addOnCreditDialogVisible: false,//新增挂账类型弹窗
      addUnitModalVisible: false, // 合约单位弹出框
      hasInitTable0: false, // 区分中西处方
      hasInitTable1: false, // 区分中西处方
      patientFormDisabled: false,//患者表单置灰
      payModalVisible: false,//支付弹出框
      paymentCode: '',//支付码
      terminalId: null,//系统序号
      scanTimer: null,//防抖
      isProcessing: false,//支付判断
      isSuccess: false,//支付判断
      scanStatus: 'waiting', // waiting|processing|success
      errorMessage: '付款失败,请重试', // waiting|processing|success
      resetTimer: null,
      countdown: 5, // 倒计时秒数
      countdownInterval: null, // 倒计时定时器
      orderId: null,//回调订单ID
      countdownStartTime: 0,    // 记录倒计时开始时间
      animationFrameId: null,   // 存储动画帧ID

      //表格数据容器
      patientTableData: [],//选择患者表格
      tableData1: [],//主表格
      tableData2: [],//西药表格
      tableData3: [],//中药表格
      tableData4: [],//代收费病人列表
      tableData5: [],//代收费病人列表详情
      tableData6: [],//挂号列表
      tableData7: [],//收费列表
      currentRowData: {},//中西处方选择的当前行数据
      activeTab: 'classInfo',

      //下拉框容器
      provinces: [],  // 所有省份
      cityOption: [],     // 当前省下的城市
      countyOption: [],    // 当前市下的区县
      townOption: [],    // 区县下的乡
      villageOption: [],    // 区县下的乡
      prhCostOption: [],//病员费别
      prhTypeOption: [],//病员类别
      rltsEntitiesOption: [],//联系人关系
      contractUnitOption: [],//合约单位
      onCreditOption: [],//挂账类型
      untAtteOption: [],//往来单位新增---单位属性
      deptOptions: [],//科室下拉框
      doctorOptions: [],//医生下拉框
      chargingPriceOptions: [],//项目价格下拉框
      registerOptions: [],//挂号类别
      ntlyOptions: [],//国籍
      medicationFrequencyOptions: [],//给药方式
      cachedRequestNo: '',
      dosaUntOptions: [],//单位
      addUnitType: [], //合约单位动态表单
      nationOption: [],//民族下拉框
      certypeOption: [],//证件下拉框
      profttlOption: [],//职业下拉框
      feeTypeOption: [],//病案费别下拉框
      userOptions: [],//当前登陆人用户信息
      ticketTypeOption: [{id: 1, label: '普通门诊发票'}],
      orderTypeOptions: [{id: 0, label: '西药处方费'}, {id: 1, label: '中药处方费'}, {id: 2, label: '检查费'}, {
        id: 3,
        label: '检验费'
      }, {id: 4, label: '处置项目费'}, {id: 5, label: '快速就诊费'}, {id: 6, label: '关联处置费'}],
      payTypeOption: [{id: 2, label: '支付宝'}, {id: 3, label: '微信'}],
      stateOption: [{id: 0, label: '禁用'}, {id: 1, label: '可用'}],
      sexOptions: [{id: '1', label: '男'}, {id: '2', label: '女'}],
      payTypeOptions: [{id: 1, label: '现金'}, {id: 2, label: '支付宝'}, {id: 3, label: '微信'},
        {id: 4, label: '银行卡'}, {id: 5, label: '医保'}, {id: 6, label: '优惠支付'},
        {id: 7, label: '健康卡支付'}, {id: 8, label: '聚合支付'}, {id: 9, label: '组合支付'},
      ],
      payStateOptions: [{id: 0, label: '否'}, {id: 1, label: '是'}],
      psnCertTypeOptions: [{id: '01', label: '居民身份证'}, {id: '02', label: '居民户口薄'}, {
        id: '03',
        label: '护照'
      }, {id: '04', label: '军官证'}
        , {id: '05', label: '驾驶证'}, {id: '06', label: '港澳居民来往内地通行证'}, {
          id: '07',
          label: '台湾居民来往内地通行证'
        }, {id: '08', label: '出生医学证明'}, {id: '99', label: '其他'}],
      gendOptions: [{id: '0', label: '未知'}, {id: '1', label: '男'}, {id: '2', label: '女'}, {id: '9', label: '未知'}],
      mdtrtCertTypeOptions: [{id: '01', label: '医保电子凭证'}, {id: '02', label: '居民身份证'}, {
        id: '03',
        label: '社会保障卡'
      }, {id: '04', label: '终端扫码'}, {id: '05', label: '终端扫脸'}],
      ybMedTypeOptions: [
        {id: '11', label: '普通门诊'},
        {id: '115301', label: '复明7号'},
        {id: '1301', label: '急诊抢救'},
        {id: '140104', label: '门诊慢病'},
        {id: '140201', label: '门诊特病'},
        {id: '16', label: '中医特色门诊'},
        {id: '21', label: '普通住院'},
        {id: '210303', label: '精神病住院'},
        {id: '23', label: '转外诊治住院'},
        {id: '26', label: '单病种住院'},
        {id: '28', label: '日间手术'},
        {id: '41', label: '定点药店购药'},
        {id: '51', label: '生育门诊'},
        {id: '52', label: '生育住院'},
        {id: '5207', label: '其他生育相关住院'},
        {id: '910202', label: '国家谈判药门诊'},
        {id: '9107', label: '体检'},
        {id: '110202', label: '特药门诊'},
        {id: '9208', label: '长期护理专护'},
        {id: '9209', label: '长期护理养护'},
        {id: '990601', label: '无他方责任意外伤害住院'},
        {id: '992001', label: '门诊特检特治'},
        {id: '31', label: '院前抢救'},
        {id: '81', label: '意外伤害门诊'},
        {id: '992102', label: '透析'},
        {id: '994101', label: '工伤门诊'},
        {id: '994102', label: '工伤住院'},
        {id: '1102', label: '新冠门诊'},
        {id: '2110', label: '新冠住院'}
      ],
      clrTypeOptions: [
        {id: '11', label: '门诊'},
        {id: '12', label: '门诊挂号'},
        {id: '14', label: '门诊慢特病'},
        {id: '15', label: '两病门诊'},
        {id: '18', label: '特药购药'},
        {id: '21', label: '住院'},
        {id: '27', label: '单病种住院'},
        {id: '28', label: '日间手术'},
        {id: '41', label: '药店购药'},
        {id: '51', label: '暂缓结算'},
        {id: '53', label: '生育门诊'},
        {id: '99', label: '其他'},
        {id: '9907', label: '总控'},
        {id: '9908', label: '非总控'},
        {id: '9909', label: '域内异地'},
        {id: '9914', label: '签约服务费'},
        {id: '9925', label: '生育并发症'},
        {id: '9928', label: '新冠门诊'},
        {id: '9929', label: '新冠住院'},
        {id: '9949', label: '病种付费'},
        {id: '9950', label: '职工药店购药清算'},
        {id: '9972', label: '门特鉴定'},
        {id: '9974', label: '域外异地药店购药'},
        {id: '9975', label: '域内异地门慢门特'},
        {id: '9977', label: '产前检查'},
        {id: '9978', label: '普通生育住院'},
        {id: '9985', label: '终止妊娠'},
        {id: '9986', label: '终生手术'},
        {id: '9987', label: '域外异地门慢门特'},
        {id: '99914', label: '人头付费'},
        {id: '99915', label: '职工门诊清算'},
        {id: '99922', label: '职工门诊慢特病清算'},
        {id: '99923', label: '单病种'},
        {id: '99927', label: '职工住院清算'},
        {id: '99928', label: '精神病住院'},
        {id: '99933', label: '职工生育住院清算'},
        {id: '99934', label: '日间病床'},
        {id: '99938', label: '总控管理'},
        {id: '99939', label: '城乡门诊统筹清算'},
        {id: '99940', label: '生育住院'},
        {id: '99943', label: '糖尿病人头付费(药店取药)'},
        {id: '99945', label: '城乡门诊慢特病清算'},
        {id: '99946', label: '新丙肝人头付费'},
        {id: '99948', label: '城乡住院清算'},
        {id: '99949', label: '生育定额住院'},
        {id: '99950', label: '腹膜透析人头付费'},
        {id: '99952', label: '异地医疗费用清算'},
        {id: '99953', label: '计划生育手术'},
        {id: '99958', label: '国家谈判药品支付'},
        {id: '99959', label: '医疗费用清算'},
        {id: '99960', label: '门诊两病'},
        {id: '99961', label: '糖尿病病人头付费药店'},
        {id: '99962', label: '门诊癌症筛查'},
        {id: '99963', label: '域外异地门诊'},
        {id: '99967', label: '糖尿病人头付费药店项目付费'},
        {id: '99968', label: '域外异地住院'}
      ],
      cvlservFlagOptions: [{id: '0', label: '否'}, {id: '1', label: '是'}],
      natyOptions: [{id: '01', label: '汉族'}, {id: '02', label: '蒙古族'}, {id: '03', label: '回族'}, {
        id: '04',
        label: '藏族'
      },
        {id: '05', label: '维吾尔族'}, {id: '06', label: '苗族'}, {id: '07', label: '彝族'}, {id: '08', label: '壮族'},
        {id: '09', label: '布依族'}, {id: '10', label: '朝鲜族'}, {id: '11', label: '满族'}, {id: '12', label: '侗族'},
        {id: '13', label: '瑶族'}, {id: '14', label: '白族'}, {id: '15', label: '土家族'}, {id: '16', label: '哈尼族'},
        {id: '17', label: '哈萨克族'}, {id: '18', label: '傣族'}, {id: '19', label: '黎族'}, {
          id: '20',
          label: '傈僳族'
        },
        {id: '21', label: '佤族'}, {id: '22', label: '畲族'}, {id: '23', label: '高山族'}, {id: '24', label: '拉祜族'},
        {id: '25', label: '水族'}, {id: '26', label: '东乡族'}, {id: '27', label: '纳西族'}, {
          id: '28',
          label: '景颇族'
        },
        {id: '29', label: '柯尔克孜族'}, {id: '30', label: '土族'}, {id: '31', label: '达斡尔族'}, {
          id: '32',
          label: '仫佬族'
        },
        {id: '33', label: '羌族'}, {id: '34', label: '布朗族'}, {id: '35', label: '撒拉族'}, {
          id: '36',
          label: '毛南族'
        },
        {id: '37', label: '仡佬族'}, {id: '38', label: '锡伯族'}, {id: '39', label: '阿昌族'}, {
          id: '40',
          label: '普米族'
        },
        {id: '41', label: '塔吉克族'}, {id: '42', label: '怒族'}, {id: '43', label: '乌孜别克族'}, {
          id: '44',
          label: '俄罗斯族'
        },
        {id: '45', label: '鄂温克族'}, {id: '46', label: '德昂族'}, {id: '47', label: '保安族'}, {
          id: '48',
          label: '裕固族'
        }, {id: '49', label: '京族'},
        {id: '50', label: '塔塔尔族'}, {id: '51', label: '独龙族'}, {id: '52', label: '鄂伦春族'}, {
          id: '53',
          label: '赫哲族'
        }, {id: '54', label: '门巴族'}, {id: '55', label: '珞巴族'}, {id: '56', label: '基诺族'}, {
          id: '57',
          label: '未说明'
        }
      ],
      insutypeOptions: [
        {id: '310', label: '职工基本医疗保险'},
        {id: '31003', label: '医疗保险个人账户（用人单位）'},
        {id: '312', label: '农民工住院医疗'},
        {id: '320', label: '公务员医疗补助'},
        {id: '321', label: '公务员医疗补助（市直统发）'},
        {id: '323', label: '公务员医疗补助（市直非统发）'},
        {id: '330', label: '大额医疗费用补助'},
        {id: '331', label: '二次补助'},
        {id: '340', label: '离休人员医疗保障'},
        {id: '350', label: '一至六级残废军人医疗补助'},
        {id: '360', label: '老红军医疗保障'},
        {id: '370', label: '企业补充医疗保险'},
        {id: '380', label: '新型农村合作医疗'},
        {id: '390', label: '城乡居民基本医疗保险'},
        {id: '391', label: '城镇居民基本医疗保险'},
        {id: '392', label: '城乡居民大病医疗保险'},
        {id: '399', label: '其他特殊人员医疗保障'},
        {id: '39901', label: '劳模医疗保障'},
        {id: '39902', label: '补充百分之十医疗'},
        {id: '39903', label: '城乡居民补充医疗保险'},
        {id: '39904', label: '建国前老工人医疗保险'},
        {id: '39905', label: '二乙医疗保险'},
        {id: '39906', label: '意外伤害医疗保险'},
        {id: '39907', label: '公费医疗照顾保险'},
        {id: '39908', label: '超转人员医疗保险'},
        {id: '39909', label: '处级干部医疗补助'},
        {id: '39910', label: '机关生育保险'},
        {id: '39911', label: '医疗救助补充保险'},
        {id: '39912', label: '大病统筹医疗保险'},
        {id: '399501', label: '失业保险'},
        {id: '399502', label: '失业保险'},
        {id: '399503', label: '启动基金'},
        {id: '399504', label: '天然林一次性征缴'},
        {id: '399505', label: '特慢病保险'},
        {id: '399506', label: '风险调解金'},
        {id: '399507', label: '企业工伤保险'},
        {id: '399508', label: '机关事业工伤保险'},
        {id: '399509', label: '工伤保险'},
        {id: '399510', label: '企业基本养老保险'},
        {id: '399511', label: '企业补充养老（企业年金）'},
        {id: '399512', label: '养老保险'},
        {id: '399513', label: '医疗保险'},
        {id: '399514', label: '生育保险'},
        {id: '399515', label: '企业生育保险'},
        {id: '399516', label: '机关事业生育保险'},
        {id: '410', label: '长期照护保险'},
        {id: '510', label: '生育保险'},
        {id: '520', label: '公务员生育'}
      ],
      psnTypeOptions: [
        {id: '11', label: '在职'},
        {id: '12', label: '退休人员'},
        {id: '1300', label: '离休人员'},
        {id: '136055', label: '建国初期参加革命工作退休干部'},
        {id: '1401', label: '新生儿'},
        {id: '1402', label: '学龄前儿童'},
        {id: '1403', label: '中小学生'},
        {id: '1404', label: '大学生'},
        {id: '15', label: '居民（成年）'},
        {id: '1501', label: '普通居民（成年）'},
        {id: '33', label: '一至六级伤残军人'},
        {id: '34', label: '建国前老工人'},
        {id: '99', label: '其他'},
        {id: '126003', label: '提前退休'}
      ],
      regModeOption: [
        {id: 1, label: '窗口'}, {id: 2, label: '诊间'}, {id: 3, label: '自助'},
        {id: 4, label: '预约'}, {id: 5, label: '自动'}, {id: 6, label: '收费'},
        {id: 7, label: '微信'}, {id: 8, label: 'APP'}, {id: 9, label: '分诊'}, {id: 99, label: '体检接口使用'}
      ],
      regOptions: [],
      // 表格动态列
      tableRows1: [
        {name: "发票费别", prop: "orderType", op: 'orderTypeOptions'},
        {name: "项目名称", prop: "orderType", op: 'orderTypeOptions'},
        {name: "合计金额", prop: "pric"},
        {name: "开单科室", prop: "deptId", op: 'deptOptions'},
        {name: "开单医生", prop: "createName"},
        {name: "执行科室", prop: "deptId", op: 'deptOptions'},
        {name: "数据来源", prop: "dataSource"},
        {name: "减免金额", prop: "derateMoney"},],
      tableRows2: [
        {name: "药品名称", prop: "drugName"},
        {name: "规格描述", prop: "drugSpec"},
        {name: "单位剂量", prop: "unitDose"},
        {name: "剂量单位", prop: "dosUnt", op: 'dosaUntOptions'},
        {name: "数量", prop: "cnt"},
        {name: "给药方式", prop: "medcWayId", op: 'medicationFrequencyOptions'},
        {name: "成本", prop: "purcPric"},
        {name: "单价", prop: "salePric"},
        {name: "金额", prop: "saleAmt"},],
      tableRows3: [
        {name: "药品名称", prop: "drugName"},
        {name: "付数", prop: "tcmCnt"},
        {name: "单位", prop: "unt", op: 'dosaUntOptions'},
        {name: "剂量单位", prop: "sdoseUnt", op: 'dosaUntOptions'},
        {name: "数量", prop: "cnt"},
        {name: "给药方式", prop: "medcWayId", op: 'medicationFrequencyOptions'},
        {name: "成本", prop: "purcPric"},
        {name: "单价", prop: "salePric"},
        {name: "金额", prop: "saleAmt"},
        {name: "医保编码", prop: "chsCode"},
        {name: "医保名称", prop: "chsName"}],
      tableRows4: [
        {name: "健康ID", prop: "id"},
        {name: "健康卡号", prop: "patId"},
        {name: "姓名", prop: "name"},
        {name: "身份证号", prop: "certno"},
        {name: "联系电话", prop: "conerTel"},
      ],
      tableRows5: [
        { name: "患者ID", prop: "patientId", align: "center" },
        { name: "姓名", prop: "patientName", align: "center" },
        { name: "待收费订单数", prop: "pendingOrderCount", align: "center" },
        { name: "待收费总金额", prop: "pendingTotalAmount", align: "center" },
        { name: "最近开单时间", prop: "latestOrderedAt", align: "center" },
      ],
      tableRows6: [
        {name: "项目名称", prop: "content"},
        {name: "执行单价", prop: "pric"},
        {name: "执行金额", prop: "pric"},
        {name: "开单医生", prop: "createName"},
        {name: "开单科室", prop: "deptId", op: 'deptOptions'},
        {name: "执行科室", prop: "deptId", op: 'deptOptions'},
      ],
      tableRows7: [
        {name: "姓名", prop: "name"},
        {name: "健康ID", prop: "patNo"}, {name: "性别", prop: "sex", op: 'sexOptions'},
        {name: "挂号类型", prop: "regTypeId", op: 'regOptions'},
        {name: "挂号方式", prop: "regMode", op: 'regModeOption'},
        {name: "应收金额", prop: "receivedMoney"}, {name: "实收金额", prop: "receivableMoney"},
        {name: "现金支付", prop: "cashAmt"}, {name: "网络支付", prop: "groupAmt"}, {
          name: "支付方式",
          prop: "payType",
          op: 'payTypeOptions'
        },
      ],
      tableRows8: [
        {name: "姓名", prop: "patName"},
        {name: "健康ID", prop: "patCode"}, {name: "性别", prop: "sex", op: 'sexOptions'},
        {name: "病人费别", prop: "patCostType"},
        {name: "应收金额", prop: "receAmt"},
        {name: "现金支付", prop: "cashAmt"},
        {name: "网络支付", prop: "groupAmt"},
        {name: "医保支付", prop: "chsAmt"},
        {name: "收费时间", prop: "feeTime"},
      ],

      finalReportShowFrom: {
        clinicName: '',
        staffName: '',
        timeRange: [
          dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'), // UTC时间
          dayjs().format('YYYY-MM-DD HH:mm:ss')
        ]
      },
      defaultTimeRange: [
        dayjs().startOf('year').toDate(), // 转换为 Date 对象
        dayjs().toDate() // 转换为 Date 对象
      ],

      //表单
      addUnitForm: {
        id: null,
        code: dayjs().format('YYYYMMDDHHmmss'),
        state: 1,
        area: 1,
        name: '',
        pyCode: '',
        bankName: '',
        bankNo: '',
        splerPmtno: '',
        legalRepe: '',
        mainConer: '',
        conerPhone: '',
        conerTel: '',
        conerQq: '',
        conerFax: '',
        conerPostc: '',
        url: '',
        conerMail: '',
        untAtte: 3,
        uscc: '',
        conerAdd: '',
        remark: ''
      },//合约单位新增修改表单
      addOnCreditForm: {
        beginTime: '',
        code: '',
        cotUnit: null,
        endTime: '',
        name: '',
        pycode: '',
        remarks: '',
        state: 1,
      },//挂账类型新增修改表单
      patientChooseForm: {
        id: null,
        patId: '',
        name: '',
        sex: null,
        certno: null,
        conerTel: null,
        contractUnit: null,
        healthCardNo: null,
        cardType: null,
      },//选择患者表单
      outpatientChargesForm: {
        id: null,
        patId: null,
        name: null,
        age: null,
        billingDoctor: null,
        billingDoctorId: null,
        billingDept: null,
        remainingSum: null,
        chargeItem: null,
        specification: null,
        executeDept: null,
        price: null,
        amount: null,
        patientType: null,
        ticketType: 1,
        currentTicketNo: null,
        currentTotal: null,
        discountedTotal: null,
        BeforePatId: '',
        BeforePaidAmt: null,
        BeforeReceiveAmt: null,
        BeforeChange: null,
        thisTimeTotal: null,
      },

      ybSettlementDataForm: {
        mdtrt_id: '',
        psn_no: '',
        psn_name: '',
        psn_cert_type: '',
        certno: '',
        gend: '',
        naty: '',
        brdy: '',
        insutype: '',
        psn_type: '',
        cvlserv_flag: '',
        setl_time: '',
        medfee_sumamt: '',
        fulamt_ownpay_amt: '',
        overlmt_selfpay: '',
        preselfpay_amt: '',
        inscp_scp_amt: '',
        act_pay_dedc: '',
        hifp_pay: '',
        pool_prop_selfpay: '',
        cvlserv_pay: '',
        hifes_pay: '',
        hifmi_pay: '',
        hifob_pay: '',
        maf_pay: '',
        oth_pay: '',
        fund_pay_sumamt: '',
        psn_part_amt: '',
        acct_pay: '',
        psn_cash_pay: '',
        hosp_part_amt: '',
        balc: '',
        acct_mulaid_pay: '',
        medins_setl_id: '',
        clr_optins: '',
        clr_way: '',
        clr_type: '',
        exp_content: {
          unif_pay_std: '',
          unif_pay_blnc: '',
          bkst_safeg_amt: '',
          fin_subs: '',
          care_subs: '',
          bas_sec_pool_lmt: '',
          mihisec_pool_lmt: '',
          comn_otp_year_lmt: '',
          comn_otp_mon_lmt: '',
          comn_otp_day_lmt: '',
          comn_otp_cnt_lmt: '',
          chrdise_otp_year_lmt: '',
          chrdise_otp_quat_lmt: '',
          chrdise_otp_mon_lmt: '',
          chrdise_lmt: '',
          cvlserv_acct_pay: '',
          oth_subs: '',
          bas_sev_inpool_amt: '',
          mihisec_inpool_amt: '',
          sp_psn_type: '',
          cvlserv_lmt_rm: '',
          fm_dr_sign_hc_subs: '',
          fund_blnc: '',
          hosp_payf_amt: '',
          third_pay_list: [],
          wlt_acct_pay: ''
        }
      },
      //表格头表单
      paymentForm: {
        age: null,
        aliAmt: null,
        bankAmt: null,
        bebtAmt: null,
        bebtId: null,
        bebtType: '',
        bilgDepId: null,
        bilgDepName: '',
        bilgDrId: null,
        bilgDrName: '',
        cashAmt: null,
        chsAmt: null,
        distAmt: null,
        groupAmt: null,
        invoNo: '',
        opeWay: null,
        paidAmt: null,
        patAmt: null,
        patCostType: null,
        patId: null,
        patName: '',
        patType: null,
        recdAmt: null,
        receAmt: null,
        regId: null,
        remarks: '',
        seeId: null,
        sex: null,
        shHarId: null,
        wechatAmt: null,
        balance: null,
        observation: null,
        observationAdvance: null,
        change: null,
        ids: [],
        clientId: '',
      },//门诊收费结算表单
      patientForm: {
        id: null,
        patId: '',       // 健康ID
        thrNot: false,   // 三无（复选框应为布尔值）
        name: '',           // 姓名
        sex: null,       // 性别
        identityCard: 1,
        certno: '',   //证件号码
        brdy: '',      // 出生日期
        ageYear: null,        // 年龄-岁
        ageMonth: null,       // 年龄-月
        naty: '汉族',     // 民族
        jobId: null,            // 职业
        feeType: null, // 病员费别
        prhType: null, // 病员类型
        contractUnit: null,  // 合约单位
        isSpecial: '否',    // 特殊人群
        conerName: '',        // 联系人
        conerTel: '',          // 联系电话
        conerRltsId: null, // 联系人关系
        province: '',       // 省
        city: '',           // 市
        county: '',         // 县
        town: '',           // 乡
        village: '',         //村
        registerDate: new Date().toISOString().split('T')[0],   // 挂号日期
        timeSlot: '1',       // 时段
        department: null,     // 科室
        doctor: null,         // 医生
        registerType: null,   // 挂号类别
        clinicRoom: null,  // 诊室
        existNumber: null,
        currentNumber: null,
        caseHistory: null,
        total: null,
        naplAddCode: null,
        conerAddCode: null,
        number: null,
      },//患者信息表单
      //新增健康档案表单
      celerityFilingForm: {
        name: '',           // 姓名
        sex: null,       // 性别
        identityCard: 1,
        certno: '',   //证件号码
        brdy: '',      // 出生日期
        ageYear: 0,        // 年龄-岁
        ageMonth: 0,       // 年龄-月
        ageDay: 0,       // 年龄-天
        naty: 1,     // 民族
        ntlyId: 1,    //国籍
        jobId: '',            // 职业
        prhType: null, // 病员类型
        contractUnit: null,  // 合约单位
        conerName: '',        // 联系人
        conerTel: '',          // 联系电话
        conerRltsId: null, // 联系人关系
        province: '',       // 省
        city: '',           // 市
        county: '',         // 县
        town: '',           // 乡
        village: '',         //村
        tel: null,
        restAddCode: null,
        naplAddCode: null,
      },


      //表单验证
      addOnCreditFormRules: {
        code: [
          {required: true, message: '请输入编码', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在2到20个字符', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur'}
        ],

        beginTime: [
          {required: true, message: '请选择开始时间', trigger: 'change'}
        ],
        endTime: [
          {required: true, message: '请选择结束时间', trigger: 'change'},
          {
            validator: (rule, value, callback) => {
              if (this.addOnCreditForm.beginTime && value) {
                if (new Date(value) < new Date(this.addOnCreditForm.beginTime)) {
                  callback(new Error('结束时间不能早于开始时间'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      }, //挂账
      addUnitRules: {
        code: [{required: true, message: '请填写合约单位编码！', trigger: 'change'}],
        name: [{required: true, message: '请填写合约单位名称！', trigger: 'change'}],
      },//合约单位
      addForm: {
        discountMoney: null,
        name: '',
        patientId: null,
        payType: null,
        receivableMoney: null,
        receivedMoney: null,
        regDepId: null,
        regDoctorId: null,
        regMode: null,
        regNum: null,
        regTypeId: null,
        regUserId: null,
        remake: '',
        utyTimeDetailsId: null,
        visitId: null,
        rgstId: null,
        /**/
        accountNumber: null,
        currentNumber: null,
        oweNumber: '0/0',
        remark: null,
        feeType: null,
        MoneyPay: null,
        healthCarePay: null,
        fitnessCardpa: null,
        unionPay: null,
        owePay: null,
        phonePay: null,
        discountsNumb: null,
        receivableNum: null,
        receiveNumber: null,
        changeNumber: null,
      },
      userInfo: {},
      unitStateOption: [{id: 1, label: '启用'}, {id: 0, label: '禁用'}],
      areaOption: [{id: 1, label: '省内'}, {id: 2, label: '省外'}, {id: 3, label: '进口'}],
      outpatientYbRegisterDialogVisible: false,
      outpatientYbRegisterForm: {
        med_type: '11',
        psnSetlway: '01',
        acct_used_flag: '1',
        dise_codg: '不适-R53.x00x005',
        begntime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        yb_1101_ReturnInfo: {},
        yb_1191_ReturnInfo: {},
        yb_2201A_ReturnInfo: {},
        yb_2203_ReturnInfo: {},
        yb_2204_ReturnInfo: {},
        yb_2206_ReturnInfo: {},
        yb_2207_ReturnInfo: {},
      },
      outpatientYbRegisterFormRules: {
        med_type: [
          {required: true, message: '请选择医疗类别', trigger: 'change'}
        ],
        psnSetlway: [
          {required: true, message: '请选择个人结算方式', trigger: 'change'}
        ],
        acct_used_flag: [
          {required: true, message: '请选择个人账户使用标志', trigger: 'change'}
        ],
        begntime: [
          {required: true, message: '请选择就诊开始时间', trigger: 'change'}
        ],
        dise_codg: [
          {required: true, message: '请选择疾病诊断', trigger: 'change'}
        ]
      },
      medTypeOptions: [],
      westDiagnoseOptions: [],
      psnSetlwayOptions: [],
      acctUsedFlagOptions: [],
      drugUntAndMinUnitOptions: [],
      drugDosageOptions: [],
      westDiagnoseLoading: false,
      systemParameterList: [],
      cashAndPaymentList: [],
    };
  },
  beforeDestroy() {
    // 组件销毁时移除监听，避免内存泄漏
    window.removeEventListener('keydown', this.handleKeyPress);
  },
  computed: {
    totalPaid() {
      let sum = 0;
      this.dynamicPaymentMethods.forEach(method => {
        const amount = Number(this.dynamicPaymentValues[method.id]) || 0;
        sum += amount;
      });
      return sum;
    },
    // 还需支付金额（应付 - 已付，不会为负）
    remainingToPay() {
      const shouldPay = Number(this.outpatientChargesForm.currentTotal) || 0;
      const remain = shouldPay - this.totalPaid;
      return remain > 0 ? remain : 0;
    },
    // 找零金额（已付 - 应付，不会为负）
    changeAmount() {
      const shouldPay = Number(this.outpatientChargesForm.currentTotal) || 0;
      const change = this.totalPaid - shouldPay;
      return change > 0 ? change : 0;
    },
    isYbButtonDisabled() {
      return !this.userInfo || this.userInfo.isInsurance !== '1';
    },
    dynamicPaymentRows() {
      const rows = [];
      for (let i = 0; i < this.dynamicPaymentMethods.length; i += 3) {
        rows.push(this.dynamicPaymentMethods.slice(i, i + 3));
      }
      return rows;
    },
  },
  async mounted() {
    this.addUnitType = AddType.map(function (v) {
      return v
    })
    window.addEventListener('keydown', this.handleKeyPress);
    this.loadData();
    this.getFinanceclassList();
    this.loadPaymentMethods();
    this.terminalId = parseInt(localStorage.getItem('terminalId'));
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
    this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'];
    this.deptOptions = this.$store.getters['preload/getDeptListOptions'];
    this.docphrOptions = this.$store.getters['preload/getDocphrListOptions'];
    this.systemParameterList = this.$store.getters['preload/getSystemListOptions'];
    this.medicationFrequencyOptions = this.$store.getters['preload/getMedicationFrequency'];
    if (!this.$store.state.dict || Object.keys(this.$store.state.dict).length === 0) {
      await this.$store.dispatch('fetchDictData')
      await this.dict(this.$store.state.dict)
    } else {
      await this.dict(this.$store.state.dict)
    }
  },
  methods: {
    // 选中订单
    handleSelectedOrders(selection) {
      this.selectedOrderData = selection;
      this.selectedOrderIds = selection.map(item => item.id || item.orderId);
      this.totalChargeAmount = selection.reduce((sum, item) => sum + (item.totalAmount || 0), 0);
    },

// 获取选中总金额
    getSelectedTotalAmount() {
      return this.totalChargeAmount.toFixed(2);
    },
    // 双击切换行展开/收起
    handleRowDblclick(row) {
      const expandRows = this.$refs.tableData5?.store.states.expandRows || [];
      const index = expandRows.indexOf(row);

      if (index > -1) {
        // 已展开则收起
        this.$refs.payDetailTable?.toggleRowExpansion(row, false);
      } else {
        // 未展开则展开
        this.$refs.payDetailTable?.toggleRowExpansion(row, true);
      }
    },
    async handleSearchPatient() {
      const patId = this.outpatientChargesForm.patId;

      // 如果健康ID为空，查询所有患者（用于患者选择弹窗）
      if (!patId || patId.trim() === '') {
        try {
          const res = await getDocphrClinicList({ condtion: '' });
          if (res.data && res.data.length > 0) {
            this.patientTableData = res.data;
            this.patientDialogVisible = true;
          } else {
            this.$message.warning('暂无患者数据');
          }
        } catch (error) {
          console.error('查询所有患者失败:', error);
          this.$message.error('查询失败，请重试');
        }
        return;
      }

      try {
        const res = await getDocphrClinicList({ condtion: patId.trim() });

        if (res.data && res.data.length > 0) {
          this.patientTableData = res.data;
          this.patientDialogVisible = true;
        } else {
          this.$message.warning('未找到该患者信息，请确认健康ID是否正确');
          this.patientTableData = [];
          this.patientDialogVisible = false;
        }
      } catch (error) {
        console.error('搜索患者失败:', error);
        this.$message.error('搜索失败，请重试');
      }
    },
    getItemTypeText(itemType) {
      const map = {
        1: '西药',
        2: '中药',
        4: '理疗',
        5: '卫材',
        6: '输液/治疗',
        7: '检查',
        8: '检验',
        9: '挂号费',
        10: '其他'
      };
      return map[itemType] || '-';
    },
    handleAssignPayment(methodId) {
      // 应付金额
      const shouldPay = Number(this.outpatientChargesForm.currentTotal) || 0;
      // 计算除当前支付方式外的其他支付方式总额
      let otherTotal = 0;
      this.dynamicPaymentMethods.forEach(method => {
        if (method.id !== methodId) {
          otherTotal += Number(this.dynamicPaymentValues[method.id]) || 0;
        }
      });
      // 剩余需支付金额 = 应付 - 其他总额（不能为负）
      let remaining = shouldPay - otherTotal;
      if (remaining < 0) remaining = 0;
      // 如果剩余金额为0，可提示
      if (remaining === 0) {
        this.$message.warning('当前已足额支付，无需再分配');
        return;
      }
      // 设置当前支付方式金额为剩余金额（保留两位小数）
      this.dynamicPaymentValues[methodId] = Number(remaining.toFixed(2));
      // 触发更新汇总
      this.calculateDynamicPayments();
    },
    async loadPaymentMethods() {
      try {
        const res = await getPatternPaymentList();
        if (res.code === 200) {
          this.dynamicPaymentMethods = res.data;
          this.initDynamicPaymentValues();
        }
      } catch (error) {
        console.error('加载支付方式失败:', error);
      }
    },

    // 初始化动态支付值
    initDynamicPaymentValues() {
      this.dynamicPaymentValues = {};
      this.dynamicPaymentMethods.forEach(method => {
        // 设置默认值
        let defaultValue = 0;

        // 如果是医保，设置医保支付金额
        if (method.wayCode === 'YB' || method.wayName.includes('医保')) {
          defaultValue = this.outpatientYbRegisterForm.yb_2206_ReturnInfo?.fund_pay_sumamt || 0;
          this.paymentForm.chsAmt = defaultValue;
        }

        this.$set(this.dynamicPaymentValues, method.id, defaultValue);
      });

      // 重新计算
      this.calculateDynamicPayments();
    },
    calculateDynamicPayments() {
      // 先确保所有支付方式的值非负
      this.dynamicPaymentMethods.forEach(method => {
        let val = this.dynamicPaymentValues[method.id];
        if (val === null || val === undefined || isNaN(val) || val < 0) {
          this.dynamicPaymentValues[method.id] = 0;
        } else {
          this.dynamicPaymentValues[method.id] = Number(val.toFixed(2));
        }
      });

      // 原有的计算总金额逻辑...
      let totalPaid = 0;
      this.dynamicPaymentMethods.forEach(method => {
        totalPaid += Number(this.dynamicPaymentValues[method.id]) || 0;
      });
      this.paymentForm.recdAmt = totalPaid.toFixed(2);
      const shouldPay = Number(this.outpatientChargesForm.currentTotal) || 0;
      this.paymentForm.change = (totalPaid - shouldPay).toFixed(2);
      if (Number(this.paymentForm.change) < 0) this.paymentForm.change = '0.00';
    },

    // 组装动态支付数据
    assembleDynamicPayment() {
      this.paymentForm.payWay = [];

      this.dynamicPaymentMethods.forEach(method => {
        const amount = Number(this.dynamicPaymentValues[method.id]) || 0;
        if (amount > 0) {  // 只组装有金额的支付方式
          this.paymentForm.payWay.push({
            amount: amount,
            uniCode:this.cashAndPaymentList.find(item => item.id  ===  method.classId)?.uniCode,
            classId: method.classId,
            wayId: method.id
          });
        }
      });
    },
    async getFinanceclassList() {
      const res = await getFinanceclassList({status: 1});
      this.cashAndPaymentList = res.data || res || []
    },
    handleRefreshPatientInfo() {
      // 如果有当前患者ID，重新查询患者信息
      if (this.outpatientChargesForm.patId) {
        this.outpatientChargesForm.patId = this.outpatientChargesForm.cardId;
        this.handleSearch();
      } else {
        // 如果没有患者ID，清空表单
        this.outpatientChargesForm = {
          patId: '',
          name: '',
          age: '',
          billingDoctor: '',
          billingDept: '',
          patientType: ''
        };
      }
      this.$message({
        message: '患者信息已刷新',
        type: 'success',
        duration: 1500
      });
    },
    async initData() {
      this.terminalId = parseInt(localStorage.getItem('terminalId'));
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
      this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'];
      this.deptOptions = this.$store.getters['preload/getDeptListOptions'];
      this.docphrOptions = this.$store.getters['preload/getDocphrListOptions'];
      this.systemParameterList = this.$store.getters['preload/getSystemListOptions'];
      this.dosaUntOptions = this.$store.getters['preload/getDosaUntListOption'];
      this.medicationFrequencyOptions = this.$store.getters['preload/getMedicationFrequencyOptions'];
      if (!this.$store.state.dict || Object.keys(this.$store.state.dict).length === 0) {
        await this.$store.dispatch('fetchDictData')
        await this.dict(this.$store.state.dict)
      } else {
        await this.dict(this.$store.state.dict)
      }
    },
    // 新增专门为A组件调用的方法
    async handleExternalSearch(row) {
      await withLoading(this, '加载中...')(async () => {
        this.patientFormDisabled = true;

        // 使用传入的row参数中的patId作为搜索条件
        const res = await getDocphrList({condtion: row.certno || row.name});

        if (res.data.length > 1) {
          this.patientDialogVisible = true;
          this.patientTableData = res.data;
          return;
        } else if (res.data.length <= 0) {
          this.$message.warning("没有搜索到相关患者!请在健康档案新增或点击下方快速建档!")
          this.patientFormDisabled = false;
          return;
        }

        this.patientChooseForm = res.data[0];
        console.log(this.patientChooseForm, '通过外部调用搜索到的患者信息');
        await this.handleChoosePatient()
        this.patientFormDisabled = false;
      });
    },
    handleQueryFeeAndRegAndSettleAccountsData() {
      switch (this.activeTab) {
        case 'classInfo':
          this.handleSettleAccountsStatistics();
          break
        case 'paymentInfo':
          this.getChargeList();
          break
        case 'registrationInfo':
          this.getRegisterType();
          this.getReservationList()
          break
      }
    },
    handleCancelSettleAccounts() {
      this.settleAccountsForm = Object.assign({}, this.$options.data.call(this).settleAccountsForm);
      this.finalReportDialogVisible = false;
    },
    async handleAddSettleAccounts() {
      this.settleAccountsForm.endTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
      const res = await addSettleAccounts(this.settleAccountsForm);
      if (res.code === 200) {
        this.handleCancelSettleAccounts();
      } else {
        this.$message.warning(res.message);
      }
    },
    async handleSettleAccountsStatistics() {
      try {
        const res = await getLastSettleAccountsTime();

        const defaultStartTime = dayjs('2025-01-01').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        let startTime = res.data?.endTime ? res.data.endTime : defaultStartTime;
        this.finalReportShowFrom.timeRange[0] = startTime;
        const [feeList, registerList] = await Promise.all([
          getFeeList({
            startTime: this.finalReportShowFrom.timeRange[0],
            endTime: this.finalReportShowFrom.timeRange[1],
            payState: 1
          }),
          getRegisterList({
            startTime: this.finalReportShowFrom.timeRange[0],
            endTime: this.finalReportShowFrom.timeRange[1],
            payState: 1
          })
        ]);
        //收费现金
        const feeCashAmt = feeList.data?.reduce((sum, item) => sum + (Number(item.cashAmt) || 0), 0);
        //挂号现金
        const copyRegisterList = JSON.parse(JSON.stringify(registerList.data))?.filter(item => item.regState === 0);
        //作废单据
        const copyCancelRegisterList = JSON.parse(JSON.stringify(registerList.data))?.filter(item => item.regState === 1);
        //挂号总金额
        const registerTotal = copyRegisterList?.reduce((sum, item) => sum + (Number(item.receivableMoney) || 0), 0);
        //挂号现金
        const registerCashAmt = copyRegisterList?.reduce((sum, item) => sum + (Number(item.cashAmt) || 0), 0);
        //挂号优惠
        const registerDiscount = copyRegisterList?.reduce((sum, item) => sum + (Number(item.discountMoney) || 0), 0);
        //聚合
        const registerGroupAmt = copyRegisterList?.reduce((sum, item) => sum + (Number(item.groupAmt) || 0), 0);

        this.settleAccountsForm.settleTime = this.finalReportShowFrom.timeRange[1];
        this.settleAccountsForm.feeIds = feeList.data?.map(item => item.id);
        this.settleAccountsForm.regIds = copyRegisterList?.map(item => item.id);
        this.settleAccountsForm.startTime = startTime;
        this.settleAccountsForm.amount = feeCashAmt + registerCashAmt;
        this.settleAccountsForm.feeAmount = feeList.data.reduce((sum, item) => sum + (Number(item.paidAmt) || 0), 0);
        this.settleAccountsForm.feeCashAmt = feeCashAmt;
        this.settleAccountsForm.feeGroupAmt = feeList.data.reduce((sum, item) => sum + (Number(item.groupAmt) || 0), 0);
        this.settleAccountsForm.regAmount = registerTotal;
        this.settleAccountsForm.regCashAmt = registerCashAmt;
        this.settleAccountsForm.regGroupAmt = registerGroupAmt;
        this.settleAccountsForm.regNum = copyRegisterList.length;
        this.settleAccountsForm.regReturnNum = copyCancelRegisterList.length;
        this.settleAccountsForm.submitCash = feeCashAmt + registerCashAmt;
        this.settleAccountsForm.regDiscount = registerDiscount;
        this.settleAccountsForm.creditPayment = feeList.data.reduce((sum, item) => sum + (Number(item.bebtAmt) || 0), 0);
        this.settleAccountsForm.otherPaymentCharge = null;
        this.settleAccountsForm.socialSecurityPaymentCharge = feeList.data.reduce((sum, item) => sum + (Number(item.chsAmt) || 0), 0);
      } catch (error) {
        console.error('结算统计出错:', error);
        throw error;
      }
    },

    async handleGetSystemParameterList() {
      const res = await getSystemList()
      this.systemParameterList = res.data || []
      console.log(this.systemParameterList, 'this.systemParameterListthis.systemParameterList')
    },
    handleCancelYbData() {
      this.handleYB_2202_Upload();
      this.ybSettlementDataDialogVisible = false;
    },

    handleClearYbFormAfterCompletion() {
      this.ybSettlementDataForm = Object.assign({}, this.$options.data.call(this).ybSettlementDataForm)
      this.ybSettlementDataDialogVisible = false;
    },

    handleConfirmYbData() {
      this.settleAccountsDialogVisible = true;
      this.calculatePayments();
      this.$nextTick(() => {
        // 找到 ref="recdAmt" 的输入框并聚焦
        if (this.$refs.recdAmt) {
          this.$refs.recdAmt.focus();
        }
      });
    },

    async getChargingPriceYbCode(id) {
      const res = await getCategory({regTyped: id})
      if (res.code === 200) {
        return res.data.costnametableVOS.find(item => item.registerid === id);
      } else {
        this.$message.warning(res.message);
        return false;
      }
    },

    /**
     * 添加门诊收费结算账户
     */
    async addYbOutpatientSettleAccounts(data, transactionInputJson, transactionOutputJson, feeId) {
      const newItem = {
        feeId: feeId,
        patientId: this.tableData1[0].patientId,
        psnNo: data.psn_no,
        seeDoctorId: this.tableData1[0].seeDoctor,
        settlementEventId: data.setl_id,
        afterPersonalAccount: data.balc,
        assistanceFundExpenditure: data.maf_pay,
        accountMutualAidPayment: data.acct_mulaid_pay,
        basicFundExpenditure: data.hifp_pay,
        bottomSecurityGuarantee: '',
        cashPaymentAmount: data.psn_cash_pay,
        consumableTraceabilityCodes: '',
        dualDesignatedInstitutionType: '',
        hiFeesetlType: '',
        institutionSettlementId: data.medine_setl_id,
        basicMedicalPoolFundExpenditure: data.hifp_pay,
        fullSelfPaymentAmount: data.fulamt_ownpay_amt,
        insuranceType: data.insutype,
        isCanceled: 0,
        liquidationCategory: data.clr_type,
        liquidationHandlingInstitution: data.clr_optins,
        liquidationAgency: data.clr_optins,
        liquidationMethod: data.clr_way,
        medicalInsuranceWalletPaymentAmount: data.balc,
        minimumDrugTraceabilityCodes: '',
        mutualPaymentAmount: '',
        occurrenceTime: data.setl_time,
        medicalAssistanceFundExpenditure: data.maf_pay,
        medicalInstitutionSettlementId: data.medins_setl_id,
        otherFundExpenditure: data.oth_pay,
        patientName: data.psn_name,
        paymentSequence: data.setl_id,
        personalAccountExpenditure: data.acct_pay,
        personalSettlementMethod: data.clr_way,
        remainingBalanceAfterPayment: data.balc - data.acct_pay,
        settlementSequence: data.setl_id,
        settlementTime: data.setl_time,
        totalFundPayment: data.fund_pay_sumamt,
        totalMedicalExpense: data.medfee_sumamt,
        totalSelfFundedAmount: data.fulamt_ownpay_amt,
        transactionInputJson: transactionInputJson,
        transactionOutputJson: transactionOutputJson,
        visitEventId: this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
        mdtrtId: this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
      };

      const res = await addYbOutpatientSettleAccounts(newItem);
      if (!res.data) {
        await this.handleYB_2208_Upload();
      }
      return res.data;
    },

    /**
     * 更新门诊收费结算账户状态
     */
    async updateYbOutpatientSettleAccounts(mdtrt_id) {
      const res = await getYbOutpatientSettleAccounts({settlementEventId: mdtrt_id});
      if (res.code === 200) {
        res.data.isCanceled = 1;
        updateYbOutpatientSettleAccounts(res.data);
        return true;
      }
      return false;
    },

    /**
     * 1191交易 - 电子凭证上传 (门诊收费版)
     */
    async handleYB_1191_Upload(mdtrtCretType) {
      // 添加请求锁
      if (this.isRequesting) {
        return false;
      }

      this.isRequesting = true;

      try {
        const ybTemplate = buildYbRequest(this.signNo, '1191', this.userInfo.mdtrtareaAdmvs);
        ybTemplate.body = {
          ...ybTemplate.body,
          input: {
            data: {
              mdtrt_cert_type: mdtrtCretType,
              cardtype: '0',
              businesstype: '01101',
              operatorid: this.userInfo.staffId.toString(),
              operatorname: this.userInfo.staffName,
              officeid: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept)?.specialtyCode || '',
              officename: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept)?.specialtyName || '',
            }
          },
          transType: "ec.query",
          orgId: this.userInfo.clinicCode,
        };

        const res = await addYbRquestData({
          infno: '1191',
          mdtrtareaAdmvs: this.userInfo.mdtrtareaAdmvs,
          data: JSON.stringify(ybTemplate),
          patientId: this.userInfo.staffId,
          patientName: this.userInfo.staffName
        });

        if (res.code !== 200) {
          this.$message.error('交易编号:【1191】请求备份失败: ' + (res.message || '未知错误'));
          return false;
        }

        const initResult = await handleYB_1101_Upload({
          fixmedins_code: this.userInfo.clinicCode,
          infosyscode: res.data.infosyscode,
          infosyssign: res.data.infoSysSign,
          service_url: 'http://10.114.177.55:8080/eapdomain/callService'
        });

        if (!initResult.success) {
          this.$message.error('COM服务初始化失败: ' + initResult.error);
          return false;
        }

        let initResponse = JSON.parse(initResult.data);
        if (initResponse && initResponse.infcode !== 0) {
          this.$message.warning(initData.err_msg || 'ocx服务初始化异常');
          return false;
        }

        // 2. 调用 BusinessHandleW 方法
        const businessParams = {
          fixmedins_code: this.userInfo.clinicCode,
          infosyscode: res.data.infosyscode,
          infosyssign: res.data.infoSysSign, // 确认使用正确的签名字段
          input_data: ybTemplate.body
        };

        const businessResult = await handleYB_Business_Upload(businessParams);
        if (!businessResult.success) {
          this.$message.error('业务处理失败: ' + businessResult.error);
          return false;
        }

        let businessResponse = JSON.parse(businessResult.data);
        console.log(businessResponse, 'businessResponsebusinessResponse')
        if (businessResponse.infcode !== 0) {
          this.$message.warning(businessResult.data.err_msg);
          return false;
        }

        // 备份响应数据
        addYbResponseData({
          id: res.data.id,
          infno: '1191',
          data: JSON.stringify(businessResult)
        });
        let patientData = this.docphrOptions.findIndex(item => item.certno === businessResponse.output.ecinfo.idno);
        if (mdtrtCretType === '01') {
          if (patientData > 0) {
            //this.patientChooseForm.patId = businessResponse.output.ecinfo.idno;
            this.outpatientChargesForm.patId = '532129199809102314';
            await this.handleSearch();
            this.$message.success("已自动匹配患者存在信息")
          }
        } else if (mdtrtCretType === '03') {
          if (patientData > 0) {
            //this.patientChooseForm.patId = businessResponse.output.cardinfo.certno;
            this.outpatientChargesForm.patId = '532129199809102314';
            await this.handleSearch();
            this.$message.success("已自动匹配患者存在信息")
          }
        }
        this.outpatientYbRegisterForm.yb_1191_ReturnInfo = businessResponse;
        return true;

      } catch (error) {
        this.$message.error('交易编号:【1191】系统异常: ' + (error.message || '未知错误'));
        return false;
      } finally {
        this.isRequesting = false;
      }
    },

    /**
     * 处理电子凭证患者信息
     */
    async handlePatientByECInfo(ecinfo) {
      const patientData = this.docphrOptions.findIndex(item => item.certno === ecinfo.idno);
      if (patientData > 0) {
        this.outpatientChargesForm.patId = '532129199809102314';
        await this.handleSearch();
        this.$message.success("已自动匹配患者存在信息");
      } else {
        this.$message.warning("健康档案不存在该患者信息,请进行快速建档");
        this.celerityFilingForm.name = ecinfo.username;
        this.celerityFilingForm.certno = ecinfo.idno;
      }
    },

    /**
     * 处理卡患者信息
     */
    async handlePatientByCardInfo(cardinfo) {
      const patientData = this.docphrOptions.findIndex(item => item.certno === cardinfo.certno);
      if (patientData > 0) {
        this.outpatientChargesForm.patId = '532129199809102314';
        await this.handleSearch();
        this.$message.success("已自动匹配患者存在信息");
      } else {
        this.$message.warning("健康档案不存在该患者信息,请进行快速建档");
        this.celerityFilingForm.name = cardinfo.psn_name;
        this.celerityFilingForm.certno = cardinfo.certno;
      }
    },

    /**
     * 2201A交易 - 门诊挂号 (门诊收费版)
     */
    async handleYB_2201A_Upload() {
      const dept = this.deptOptions.find(item => item.id === this.outpatientChargesForm.billingDept);
      if (!dept) {
        this.$message.warning("未找到对应科室");
        return false;
      }

      const result = await ybOutpatientMedical.handleYB_2201A_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        patientForm: this.outpatientChargesForm,
        rowData: {
          doctorId: this.outpatientChargesForm.billingDoctorId,
          doctorName: this.outpatientChargesForm.billingDoctor,
          specialtyCode: this.outpatientChargesForm.billingDept,
          deptName: dept.label,
          specialtyName: dept.specialtyName
        }
      });

      if (result.success) {
        if (result.data.infcode === -1) {
          this.$message.error('交易编号:【2201A】上传失败: ' + (result.data.err_msg || '未知错误'));
          return false;
        }
        this.outpatientYbRegisterForm.yb_2201A_ReturnInfo = result.data.output.data;
        return true;
      } else {
        this.$message.error('交易编号:【2201A】请求失败: ' + result.error);
        return false;
      }
    },

    /**
     * 2202交易 - 门诊挂号撤销 (门诊收费版)
     */
    async handleYB_2202_Upload() {
      const result = await ybOutpatientMedical.handleYB_2202_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        patientForm: this.outpatientChargesForm
      });

      if (result.success) {
        if (result.data.infcode === -1) {
          this.$message.error('交易编号:【2202】上传失败: ' + (result.data.err_msg || '未知错误'));
          return false;
        }
        return true;
      } else {
        this.$message.error('交易编号:【2202】请求失败: ' + result.error);
        return false;
      }
    },

    /**
     * 2203A交易 - 门诊信息上传 (门诊收费版)
     */
    async handleYB_2203A_Upload() {
      const dept = this.deptOptions.find(item => item.id === this.outpatientChargesForm.billingDept);
      const westDiagnosisRes = await getReceptionDiagnosis({category: 1, seeDoctorId: this.tableData1[0].seeDoctor});
      let chinaDiagnosisRes = await getReceptionDiagnosis({category: 2, seeDoctorId: this.tableData1[0].seeDoctor});

      chinaDiagnosisRes = chinaDiagnosisRes.map(item => ({
        ...item,
        category: 2,
      }));

      const chinaDisease = chinaDiagnosisRes.map(item => ({
        diag_type: '1',
        diag_srt_no: 2,
        diag_code: item.insuranceCode,
        diag_name: item.insuranceName,
        diag_dept: dept.label,
        dise_dor_no: this.outpatientChargesForm.billingDoctorId,
        dise_dor_name: this.outpatientChargesForm.billingDoctor,
        diag_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        vali_flag: '1'
      }));

      const chinaSyndrome = chinaDiagnosisRes.map(item => ({
        diag_type: '1',
        diag_srt_no: 3,
        diag_code: item.chineseSyndromeCode,
        diag_name: item.chineseSyndromeName,
        diag_dept: dept.label,
        dise_dor_no: this.outpatientChargesForm.billingDoctorId,
        dise_dor_name: this.outpatientChargesForm.billingDoctor,
        diag_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        vali_flag: '1'
      }));

      const westDiagnosis = westDiagnosisRes.map(item => ({
        diag_type: '1',
        diag_srt_no: 1,
        diag_code: item.insuranceCode,
        diag_name: item.insuranceName,
        diag_dept: dept.label,
        dise_dor_no: this.outpatientChargesForm.billingDoctorId,
        dise_dor_name: this.outpatientChargesForm.billingDoctor,
        diag_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        vali_flag: '1'
      }));

      const chinaDiagnosis = [...chinaDisease, ...chinaSyndrome];

      const result = await ybOutpatientMedical.handleYB_2203A_Upload_Outpatient({
        signNo: this.signNo,
        userInfo: this.userInfo,
        diagnosisData: {
          mdtrtinfo: {
            mdtrt_id: this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
            psn_no: this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
            med_type: this.outpatientYbRegisterForm.med_type,
            begntime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            dise_codg: westDiagnosisRes[0]?.insuranceCode || '',
            dise_name: westDiagnosisRes[0]?.insuranceName || '',
          },
          diseinfo: [...westDiagnosis, ...chinaDiagnosis] // 这里是数组，包含多个诊断
        }
      });

      if (result.success) {
        if (result.data.infcode === -1) {
          this.$message.error('交易编号:【2203A】上传失败: ' + (result.data.err_msg || '未知错误'));
          return false;
        }
        return true;
      } else {
        this.$message.error('交易编号:【2203A】请求失败: ' + result.error);
        return false;
      }
    },

    /**
     * 2204交易 - 门诊费用明细信息上传 (门诊收费版)
     */
    async handleYB_2204_Upload() {
      const westCondition = this.tableData1.filter(filterItem => filterItem.orderType === 0)[0]?.orderTypeId !== undefined;
      const chinaCondition = this.tableData1.filter(filterItem => filterItem.orderType === 1)[0]?.orderTypeId !== undefined;
      const disposeCondition = this.tableData1.filter(filterItem => filterItem.orderType === 4)[0]?.orderTypeId !== undefined;
      const registration = this.tableData1.filter(filterItem => filterItem.orderType === 5);

      let westDataRes;
      let chinaDataRes;
      let disposeDataRes;
      let chargingPriceYb;

      if (westCondition) {
        const orderTypeIds = this.tableData1.filter(filterItem => filterItem.orderType === 0).map(item => item.orderTypeId);
        const allResponses = await Promise.all(orderTypeIds.map(id => getWestDetail(id)));
        westDataRes = allResponses.flatMap(res => res.data.drxDetails);
      }

      if (chinaCondition) {
        const orderTypeIds = this.tableData1.filter(filterItem => filterItem.orderType === 1).map(item => item.orderTypeId);
        const allResponses = await Promise.all(orderTypeIds.map(id => getChinaDetail({id: id})));
        chinaDataRes = allResponses.flatMap(res => res.data.tcmDetailsRespVOS);
      }

      if (disposeCondition) {
        const orderTypeIds = this.tableData1.filter(filterItem => filterItem.orderType === 4).map(item => item.orderTypeId);
        const allResponses = await Promise.all(orderTypeIds.map(id => getDoctordisposeById(id)));
        disposeDataRes = allResponses.flatMap(res => res.data);
      }

      if (registration.length > 0) {
        chargingPriceYb = await this.getChargingPriceYbCode(registration[0].regTypeId);
        if (!chargingPriceYb) {
          this.$message.warning('交易编号:【2204】上传失败: 获取挂号医保编码失败!');
          return false;
        }
      }

      // 构建费用明细数据
      const feeDetailData = [
        ...(westCondition ? westDataRes.map(item => ({
          feedetl_sn: `${this.userInfo.clinicCode}${dayjs().format('YYYYMMDDHHmmss')}${this.getRandom4Digits()}`,
          mdtrt_id: this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
          psn_no: this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
          chrg_bchno: `${this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
          rxno: `${this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
          rx_circ_flag: '0',
          fee_ocur_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          med_list_codg: item.chsCode,
          medins_list_codg: item.chsName,
          det_item_fee_sumamt: item.saleAmt,
          cnt: item.cnt,
          pric: item.salePric,
          sin_dos_dscr: item.sdoseCnt,
          used_frqu_dscr: '',
          prd_days: item.prdDays,
          medc_way_dscr: '',
          bilg_dept_codg: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptCode,
          bilg_dept_name: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptName,
          bilg_dr_codg: this.outpatientChargesForm.billingDoctorId,
          bilg_dr_name: this.outpatientChargesForm.billingDoctor,
          acord_dept_codg: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptCode,
          acord_dept_name: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptName,
          orders_dr_code: this.outpatientChargesForm.billingDoctorId,
          orders_dr_name: this.outpatientChargesForm.billingDoctor,
          hosp_appr_flag: '0',
          tcmdrug_used_way: '2',
          etip_flag: '0',
          etip_hosp_code: '',
          dscg_tkdrug_flag: '',
          matn_fee_flag: '',
          exp_content: {
            act_purc_pric: item.purcPric,
            spec: item.drugSpec,
            dosform_name: this.drugDosageOptions.find(dos => dos.id === item.dosform)?.label,
            pacmatl_name: '',
            unt_name: this.drugUntAndMinUnitOptions.find(unt => unt.id === item.minUnt)?.label,
            dosunt: this.dosaUntOptions.find(dos => dos.id === item.dosUnt)?.label,
            sin_dos: item.sdoseCnt,
            orplc: '',
            used_mtd: this.medicationFrequencyOptions.find(freq => freq.id === item.medcWayId)?.label,
            medins_list_name: item.chsName || item.drugName,
            feedetl_souc: '',
            medins_brand: '',
            reg_num: '',
            dispensing_granules_flag: '',
            decoction_pieces_flag: '',
            med_chrgitm_type: '',
            trac_cnt: '',
          }
        })) : []),

        ...(chinaCondition ? chinaDataRes.map(item => ({
          feedetl_sn: `${this.userInfo.clinicCode}${dayjs().format('YYYYMMDDHHmmss')}${this.getRandom4Digits()}`,
          mdtrt_id: this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
          psn_no: this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
          chrg_bchno: `${this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
          rxno: `${this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
          rx_circ_flag: '0',
          fee_ocur_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          med_list_codg: item.chsCode,
          medins_list_codg: item.chsName,
          det_item_fee_sumamt: item.saleAmt,
          cnt: chinaDataRes.reduce((sum, item) => sum + item.cnt, 0),
          pric: item.salePric,
          sin_dos_dscr: item.rxDosCnt,
          used_frqu_dscr: '',
          prd_days: item.prdDays,
          medc_way_dscr: '',
          bilg_dept_codg: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptCode,
          bilg_dept_name: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptName,
          bilg_dr_codg: this.outpatientChargesForm.billingDoctorId,
          bilg_dr_name: this.outpatientChargesForm.billingDoctor,
          acord_dept_codg: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptCode,
          acord_dept_name: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptName,
          orders_dr_code: this.outpatientChargesForm.billingDoctorId,
          orders_dr_name: this.outpatientChargesForm.billingDoctor,
          hosp_appr_flag: '0',
          tcmdrug_used_way: '2',
          etip_flag: '0',
          etip_hosp_code: '',
          dscg_tkdrug_flag: '',
          matn_fee_flag: '',
          exp_content: {
            act_purc_pric: item.purcPric,
            unt_name: this.drugUntAndMinUnitOptions.find(unt => unt.id === item.unt)?.label,
            dosunt: this.dosaUntOptions.find(dos => dos.id === item.sdoseUnt)?.label,
            sin_dos: item.sdoseCnt,
            orplc: '',
            used_mtd: this.medicationFrequencyOptions.find(freq => freq.id === item.medcWayId)?.label,
            medins_list_name: item.chsName,
            feedetl_souc: '',
            medins_brand: '',
            reg_num: '',
            dispensing_granules_flag: item.dosform === 1 ? item.dosform : null,
            decoction_pieces_flag: item.dosform === 0 ? item.dosform : null,
            med_chrgitm_type: '',
            trac_cnt: '',
          }
        })) : []),

        ...(registration ? registration.map(item => ({
          feedetl_sn: `${this.userInfo.clinicCode}${dayjs().format('YYYYMMDDHHmmss')}${this.getRandom4Digits()}`,
          mdtrt_id: this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
          psn_no: this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
          chrg_bchno: `${this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
          rxno: `${this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
          rx_circ_flag: '0',
          fee_ocur_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          med_list_codg: chargingPriceYb.isocode,
          medins_list_codg: chargingPriceYb.isocode,
          det_item_fee_sumamt: item.pric,
          cnt: 1,
          pric: item.pric,
          sin_dos_dscr: item.rxDosCnt,
          used_frqu_dscr: '',
          prd_days: item.prdDays,
          medc_way_dscr: '',
          bilg_dept_codg: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptCode,
          bilg_dept_name: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptName,
          bilg_dr_codg: this.outpatientChargesForm.billingDoctorId,
          bilg_dr_name: this.outpatientChargesForm.billingDoctor,
          acord_dept_codg: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptCode,
          acord_dept_name: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptName,
          orders_dr_code: this.outpatientChargesForm.billingDoctorId,
          orders_dr_name: this.outpatientChargesForm.billingDoctor,
          hosp_appr_flag: '0',
          tcmdrug_used_way: '2',
          etip_flag: '0',
          etip_hosp_code: '',
          dscg_tkdrug_flag: '',
          matn_fee_flag: '',
          exp_content: {
            act_purc_pric: item.pric,
            unt_name: this.drugUntAndMinUnitOptions.find(unt => unt.id === item.unt)?.label,
            dosunt: this.dosaUntOptions.find(dos => dos.id === item.sdoseUnt)?.label,
            sin_dos: item.sdoseCnt,
            orplc: '',
            used_mtd: this.medicationFrequencyOptions.find(freq => freq.id === item.medcWayId)?.label,
            medins_list_name: chargingPriceYb.isoname,
            feedetl_souc: '',
            medins_brand: '',
            reg_num: '',
            dispensing_granules_flag: item.dosform === 1 ? item.dosform : null,
            decoction_pieces_flag: item.dosform === 0 ? item.dosform : null,
            med_chrgitm_type: '',
            trac_cnt: '',
          }
        })) : []),

        ...(disposeCondition ? disposeDataRes.map(item => ({
          feedetl_sn: `${this.userInfo.clinicCode}${dayjs().format('YYYYMMDDHHmmss')}${this.getRandom4Digits()}`,
          mdtrt_id: this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
          psn_no: this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
          chrg_bchno: `${this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
          rxno: `${this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
          rx_circ_flag: '0',
          fee_ocur_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          med_list_codg: item.isoCode,
          medins_list_codg: item.isoName,
          det_item_fee_sumamt: item.executionAmount,
          cnt: item.num,
          pric: item.executionPrice,
          used_frqu_dscr: '',
          prd_days: item.prdDays,
          medc_way_dscr: '',
          bilg_dept_codg: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptCode,
          bilg_dept_name: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptName,
          bilg_dr_codg: this.outpatientChargesForm.billingDoctorId,
          bilg_dr_name: this.outpatientChargesForm.billingDoctor,
          acord_dept_codg: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptCode,
          acord_dept_name: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept).deptName,
          orders_dr_code: this.outpatientChargesForm.billingDoctorId,
          orders_dr_name: this.outpatientChargesForm.billingDoctor,
          hosp_appr_flag: '0',
          tcmdrug_used_way: '2',
          etip_flag: '0',
          etip_hosp_code: '',
          dscg_tkdrug_flag: '',
          matn_fee_flag: '',
          exp_content: {
            act_purc_pric: item.executionPrice,
            spec: '',
            medins_list_name: item.isoName,
          }
        })) : [])
      ];

      // 检查费用明细是否为空
      if (feeDetailData.length === 0) {
        this.$message.warning('交易编号:【2204】上传失败: 费用明细列表不能为空!');
        return false;
      }

      const result = await ybOutpatientMedical.handleYB_2204_Upload_Outpatient({
        signNo: this.signNo,
        userInfo: this.userInfo,
        feeDetailData: feeDetailData // 这里是数组，包含多种类型的费用明细
      });

      if (result.success) {
        if (result.data.infcode === -1) {
          this.$message.error('交易编号:【2204】上传失败: ' + (result.data.err_msg || '未知错误'));
          return false;
        }
        this.outpatientYbRegisterForm.yb_2204_ReturnInfo = result.data.output;
        return true;
      } else {
        this.$message.error('交易编号:【2204】请求失败: ' + result.error);
        return false;
      }
    },

    /**
     * 2206交易 - 门诊预结算信息上传 (门诊收费版)
     */
    async handleYB_2206_Upload() {
      const totalAmount = this.outpatientYbRegisterForm.yb_2204_ReturnInfo.result?.reduce((sum, item) => sum + (item.pric * item.cnt), 0) || this.outpatientChargesForm.currentTotal;

      const result = await ybOutpatientMedical.handleYB_2206_Upload_Outpatient({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        totalAmount: totalAmount
      });

      if (result.success) {
        if (result.data.infcode === -1) {
          this.$message.error('交易编号:【2206】上传失败: ' + (result.data.err_msg || '未知错误'));
          return false;
        }
        this.outpatientYbRegisterForm.yb_2206_ReturnInfo = result.data.output.setlinfo;
        if (Object.keys(this.outpatientYbRegisterForm.yb_1191_ReturnInfo).length < 0) {
          await this.handleSettleAccounts();
        }
        return true;
      } else {
        this.$message.error('交易编号:【2206】请求失败: ' + result.error);
        return false;
      }
    },

    /**
     * 2207交易 - 门诊结算信息上传 (门诊收费版)
     */
    async handleYB_2207_Upload(feeId) {
      const result = await ybOutpatientMedical.handleYB_2207_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        rowData: {
          price: this.outpatientChargesForm.currentTotal
        }
      });

      if (result.success) {
        if (result.data.infcode === -1) {
          this.$message.error('交易编号:【2207】上传失败: ' + (result.data.err_msg || '未知错误'));
          await this.handleYB_2208_Upload();
          return false;
        }
        this.outpatientYbRegisterForm.yb_2207_ReturnInfo = result.data.output.setlinfo;
        await this.addYbOutpatientSettleAccounts(result.data.output.setlinfo, JSON.stringify(result.requestInfo), JSON.stringify(result.data), feeId);
        return true;
      } else {
        this.$message.error('交易编号:【2207】请求失败: ' + result.error);
        await this.handleYB_2202_Upload();
        return false;
      }
    },

    /**
     * 2208交易 - 门诊结算撤销 (门诊收费版)
     */
    async handleYB_2208_Upload() {
      const result = await ybOutpatientMedical.handleYB_2208_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm
      });

      if (result.success) {
        if (result.data.infcode === -1) {
          this.$message.error('交易编号:【2208】上传失败: ' + (result.data.err_msg || '未知错误'));
        }
        await this.updateYbOutpatientSettleAccounts(this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id);
        return true;
      } else {
        this.$message.error('交易编号:【2208】请求失败: ' + result.error);
        return false;
      }
    },

    /**
     * 1101交易 - 获取患者医保信息 (门诊收费版)
     */
    async handleGetPatientYbInfo() {
      const result = await ybOutpatientMedical.handleYB_1101_Upload({
        userInfo: this.userInfo,
        patientForm: this.patientChooseForm
      });

      if (result.success) {
        if (result.data.infcode === -1) {
          this.$message.error(result.data.err_msg);
          return false;
        }

        if (result.data.output.length <= 0) {
          this.$message.warning("该患者没有参保信息!");
          return false;
        } else {
          this.outpatientYbRegisterForm.yb_1101_ReturnInfo = result.data.output;
          return true;
        }
      } else {
        this.$message.error(result.error);
        return false;
      }
    },

    /**
     * 医保信息上传总控方法 (门诊收费版)
     */
    async handleYBInfoUpload() {
      return await withLoading(this, '医保处理中...')(async () => {
        try {
          // 1. 获取患者医保信息
          if (!(await this.handleGetPatientYbInfo())) {
            return false;
          }

          // 2. 门诊挂号
          if (!(await this.handleYB_2201A_Upload())) {
            return false;
          }

          // 3. 门诊信息上传
          if (!(await this.handleYB_2203A_Upload())) {
            await this.handleYB_2202_Upload();
            return false;
          }

          // 4. 门诊费用明细上传
          if (!(await this.handleYB_2204_Upload())) {
            await this.handleYB_2202_Upload();
            return false;
          }

          // 5. 门诊预结算
          if (!(await this.handleYB_2206_Upload())) {
            await this.handleYB_2202_Upload();
            return false;
          }

          this.$message.success('医保信息上传成功');
          this.outpatientYbRegisterDialogVisible = false;

          return true;
        } catch (error) {
          console.error('医保信息上传总控出错:', error);
          this.$message.error('医保信息上传过程中发生错误: ' + (error.message || '未知错误'));
          return false;
        }
      });
    },

    async handleSearchWestDiagnose(query) {
      console.log(query)
      // 空值或与上次查询相同则跳过
      if (!query || query === this.lastSearchQuery) {
        this.westDiagnoseOptions = [];
        return;
      }

      this.westDiagnoseLoading = true;
      this.lastSearchQuery = query;

      try {
        // 调用您的API接口
        const res = await getDocticdList({pageSize: 100, condition: query});
        if (res.code === 200) {
          if (res.data.length === 0) {
            this.$message.warning('未找到匹配的疾病诊断');
            return
          }
          this.westDiagnoseOptions = res.data.map(item => {
            return {
              id: item.id, label: item.chsName, code: item.chsCode
            }
          })
        } else {
          this.$message.warning(res.message)
        }
      } catch (error) {
        this.$message.error('搜索失败，请稍后重试');
        this.westDiagnoseOptions = [];
      } finally {
        this.westDiagnoseLoading = false;
      }
    },

    // 选中疾病后的处理
    handleGetWestDiagnose(selectedValue) {
      if (!selectedValue) return;

      // 获取选中的完整疾病信息
      const selectedDiagnose = this.westDiagnoseOptions.find(
          item => item.id === selectedValue
      );
      if (selectedDiagnose.letngh <= 0) return this.$message.warning("系统异常:请联系管理员")
      this.outpatientYbRegisterForm.dise_codg = selectedDiagnose.label + '-' + selectedDiagnose.code;
    },

    handleOutpatientYbRegisterClose() {
      this.outpatientYbRegisterForm = Object.assign({}, this.$options.data.call(this).outpatientYbRegisterForm)
      this.outpatientYbRegisterDialogVisible = false;
    },
    handleYbSwipingCardOrHumanFace(command) {
      switch (command) {
        case 'face' :

          break;
        case 'electronic' :
          this.handleYB_1191_Upload('01');
          break;
        case 'YbCard' :
          this.handleYB_1191_Upload('03');
          break;
        case 'identityCard' :
          this.outpatientYbRegisterDialogVisible = true;
          break;
      }
    },
    async getRegisterType() {
      if (this.regOptions.length > 0) return;
      const res = await getRegisterType();
      this.regOptions = res.data.map(item => {
        return {label: item.designation, id: item.id}
      })
    },
    async handleChargeListSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      await this.getChargeList();
    },
    async handleChargeListCurrentChange(val) {
      this.pageNum = val;
      await this.getChargeList();
    },

    async handleRegistrationSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      await this.getReservationList();
    },
    async handleRegistrationCurrentChange(val) {
      this.pageNum = val;
      await this.getReservationList();
    },

    async getChargeList() {
      const res = await getChargeList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        startTime: this.finalReportShowFrom.timeRange[0],
        endTime: this.finalReportShowFrom.timeRange[1],
      });
      if (res.code === 200) {
        this.tableData7 = res.data.content
            .map(item => ({
              ...item,
              feeTime: item.feeTime === null ? null : dayjs(item.feeTime).format('YYYY-MM-DD HH:mm:ss'),
            }))
        this.totalSize = res.data.totalSize;
      }
    },
    async getReservationList() {
      const newItem = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        startTime: this.finalReportShowFrom.timeRange?.[0] || '',
        endTime: this.finalReportShowFrom.timeRange?.[1] || '',
      }
      let res = await getAllReservation(newItem);
      if (res.code === 200) {
        this.totalSize = res.data.totalSize;
        this.tableData6 = res.data.content.map(item => {
          return {
            ...item,
            payType: parseInt(item.payType)
          }
        });
      } else {
        this.$message.error(res.message)
      }
    },
    handleTabClick(tab) {
      switch (tab.name) {
        case 'classInfo':
          this.activeTab = 'classInfo';
          this.handleSettleAccountsStatistics();
          break
        case 'paymentInfo':
          this.activeTab = 'paymentInfo'
          this.getChargeList();
          break
        case 'registrationInfo':
          this.activeTab = 'registrationInfo'
          this.getRegisterType();
          this.getReservationList()
          break
      }
    },
    handleOpenFinalReport() {
      this.finalReportShowFrom.clinicName = this.userInfo.clinicName;
      this.finalReportShowFrom.staffName = this.userInfo.staffName;
      this.handleSettleAccountsStatistics();
      this.finalReportDialogVisible = true;
    },
    handleCloseFinalReport() {
      this.finalReportForm = Object.assign({}, this.$options.data.call(this).finalReportForm);
      this.finalReportDialogVisible = false;
    },
    handleSaveContractUnit() {
      this.addUnitForm = Object.assign({}, this.$options.data.call(this).addUnitForm)
      this.addUnitModalVisible = true;
    },
    handleCancelAddUnit() {
      this.addUnitForm = Object.assign({}, this.$options.data.call(this).addUnitForm)
      this.addUnitModalVisible = false;
    },
    async getOutPatientCharge(row) {
      if (!row || !row.patientId) {
        this.$message.warning('请选择患者');
        return;
      }

      this.outpatientChargesForm.patId = row.patientId;
      await this.handleSearchByPatientId(row.patientId);
      this.awaitingPayDialogVisible = false;
    },
    async handleSearchByPatientId(patientId) {
      await withLoading(this, '加载中...')(async () => {
        const res = await getDocphrList({ condtion: patientId });
        if (res.data && res.data.length > 0) {
          this.patientChooseForm = res.data[0];
          await this.handleChoosePatient();
        } else {
          this.$message.warning('未找到该患者信息');
        }
      });
    },
    async getAwaitPayDetail(row, event) {
      if (!row || !row.patientId) {
        this.$message.warning('请选择患者');
        return;
      }

      try {
        const res = await getPatientsAwaitingPaymentByPatientId({
          patientId: row.patientId
        });

        if (res.code === 200) {
          this.showAwaitingPayDetail = true;
          this.tableData5 = res.data || [];
          // 清空选中
          this.selectedOrderIds = [];
          this.selectedOrderData = [];
          this.totalChargeAmount = 0;
          this.$nextTick(() => {
            if (this.$refs.tableData5) {
              this.$refs.tableData5.clearSelection();
            }
          });
        } else {
          this.$message.error(res.message || '加载明细失败');
        }
      } catch (error) {
        console.error('获取待收费明细失败:', error);
        this.$message.error('加载明细失败');
      }
    },
    // 加载待收费患者列表/患者详情
    async loadData(params = {}) {
      try {
        const requestParams = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        };

        if (params.patientId) {
          requestParams.patientId = params.patientId;
        }
        if (params.patientName) {
          requestParams.patientName = params.patientName;
        }

        const res = await getPatientsAwaitingPayment(requestParams);

        if (res.code === 200) {
          const content = (res.data.content || []).map(item => ({
            ...item,
          }));
          this.tableData4 = content;
          this.totalSize = res.data.totalSize || 0;

          // 如果搜索的是单个患者且只有一条数据，自动加载明细
          if (params.patientId && content.length === 1) {
            this.getAwaitPayDetail(content[0]);
          }

          return content; // 返回数据供调用方判断
        } else {
          this.$message.error(res.message || '加载失败');
          return [];
        }
      } catch (error) {
        console.error('加载待收费患者列表失败:', error);
        this.$message.error('加载失败');
        return [];
      }
    },

    handleKeyPress(event) {
      // 检查是否为 F9 键（兼容 key 和 keyCode）
      if (event.key === 'F9' || event.keyCode === 120) {
        event.preventDefault(); // 阻止默认行为
        this.handleIdCardData(); // 调用你的业务方法
      }
    },
    async handleIdCardData() {
      try {
        await withLoading(this, '身份证读取中...')(async () => {
          const res = await readIdCard();
          this.outpatientChargesForm.patId = res.cardno;
          await this.handleSearch()
        });
      } catch (error) {
        this.$message.error(error)
      } finally {

      }
    },

    async getSqbPaymentState() {
      const res = await getSqbPaymentState({orderId: this.orderId});
      console.log(res, 'const res = await getSqbPaymentState({ orderId: this.orderId });')
    },


    resetScanner() {
      this.scanStatus = 'waiting';
      this.paymentCode = '';
      this.countdown = 5;
      this.errorMessage = '付款失败，请重试';
      clearInterval(this.timer);
      cancelAnimationFrame(this.animationFrameId);
      this.$nextTick(() => {
        const input = this.$refs.paymentCodeInput?.$el?.querySelector('input');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    handlePayDialogOpened() {
      this.resetScanner();
      this.$nextTick(() => {
        const input = this.$refs.paymentCodeInput;
        if (input) {
          // 双重聚焦确保Element UI组件接受焦点
          input.focus();
          input.$el.querySelector('input').focus();

          // 防止意外失去焦点（扫码枪场景专用）
          this._blurHandler = () => {
            setTimeout(() => input.$el.querySelector('input').focus(), 10);
          };
          input.$el.querySelector('input').addEventListener('blur', this._blurHandler);
        }
      });
    },

    handlePayDialogClosed() {
      this.resetScanner();
      if (this._blurHandler) {
        this.$refs.paymentCodeInput?.$el
            .querySelector('input')
            .removeEventListener('blur', this._blurHandler);
      }
    },


    handleScanComplete(val) {
      clearTimeout(this.scanTimer);
      this.scanTimer = setTimeout(() => {
        val = val.trim();
        if (!val) return;

        // 验证格式
        const isAlipay = /^(25|26|27|28|29|30)\d{14,22}$/.test(val);
        const isWechat = /^(10|11|12|13|14|15)\d{16}$/.test(val);

        if (!isAlipay && !isWechat) {
          this.$message.error('付款码格式错误');
          this.errorMessage = '付款码格式错误';
          this.scanStatus = 'error';
          this.paymentCode = '';
          this.startCountdown();
          return;
        }

        // 开始处理
        this.processPayment(val);
      }, 300);
    },

    //qwe
    async processPayment(code) {
      this.scanStatus = 'processing';

      try {
        const res1 = await sqbPayment({dynamicId: code, orderId: this.orderId});

        // 处理支付结果
        if (res1.data === 'PAY_SUCCESS') {
          this.scanStatus = 'success';
          // 支付成功
          this.startCountdown();
        } else if (res1.data === 'PAY_IN_PROGRESS') {
          this.scanStatus = 'processing';
          // 支付中，开始轮询
          await this.pollPaymentStatus(20); // 最多轮询20次
        } else if (res1.data === 'PAY_ERROR') {
          this.scanStatus = 'error';
          // 支付失败
          this.handlePaymentError();
        }

      } catch (error) {
        // 网络或系统错误
        this.handlePaymentError();
      }
    },
    async pollPaymentStatus(maxAttempts) {
      let attempts = 0;
      const pollInterval = 2000; // 2秒轮询一次

      const poll = async () => {
        attempts++;

        try {
          const res = await getSqbPaymentState({orderId: this.orderId});

          if (res.data === 'PAY_SUCCESS') {
            // 轮询期间支付成功了
            this.scanStatus = 'success';
            this.startCountdown();
          } else if (res.data === 'PAY_ERROR' || attempts >= maxAttempts) {
            // 支付失败或达到最大轮询次数
            this.scanStatus = 'error';
            this.handlePaymentError();
          } else {
            // 继续轮询
            if (attempts < maxAttempts) {
              setTimeout(poll, pollInterval);
            }
          }

        } catch (error) {
          // 查询出错也视为失败
          this.handlePaymentError();
        }
      };

      // 开始轮询
      await poll();
    },

    handlePaymentError() {
      this.scanStatus = 'error';
      this.startCountdown();
      if (this.outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no !== undefined) {
        this.handleYB_2208_Upload();
      }
      this.$message.error('支付处理失败');
    },

    startCountdown() {
      // 清除现有动画帧和定时器
      cancelAnimationFrame(this.animationFrameId);
      clearInterval(this.countdownInterval);

      // 初始化倒计时
      this.countdown = 5;
      this.countdownStartTime = Date.now();

      // 启动动画帧循环
      const animate = () => {
        const elapsed = Date.now() - this.countdownStartTime;
        const remaining = Math.max(0, 5 - Math.floor(elapsed / 1000));

        // 更新显示
        this.countdown = remaining;

        if (remaining > 0) {
          // 继续下一帧
          this.animationFrameId = requestAnimationFrame(animate);
        } else {
          // 倒计时结束
          if (this.scanStatus === 'success') {
            this.handleBeforeCharge();
          }
          this.resetScanner();
        }
      };

      this.animationFrameId = requestAnimationFrame(animate);
    },


    //挂账类型修改模态框回显
    async handleOpenEditOnCredit(item) {
      const res = await getOnCreditById({id: item.id});

      const formatTime = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp.toString().length === 10 ? timestamp * 1000 : timestamp);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
      };

      this.addOnCreditForm = {
        ...res.data,
        beginTime: formatTime(res.data.beginTime),
        endTime: formatTime(res.data.endTime)
      };
      await this.getContuntList();
      this.addOnCreditDialogVisible = true;
    },

    //挂账类型新增模态框处理
    handleOpenAddOnCredit() {
      this.getContuntList();
      this.addOnCreditDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addOnCreditForm.clearValidate();
      });
    },

    //清空挂账类型数据
    handleCloseAddOnCredit() {
      this.addOnCreditForm = {};
      this.addOnCreditForm.state = 1;
      this.addOnCreditDialogVisible = false;
    },

    //挂账类型名称转拼音
    handleOnCreditNameGetPy() {
      this.addOnCreditForm.pycode =
          pinyin(this.addOnCreditForm.name, {pattern: 'first', toneType: 'none', separator: ''}).toLocaleUpperCase();
    },

    //新增修改挂账类型
    async handleAddOnCredit() {
      try {
        // 验证表单
        const valid = await this.$refs.addOnCreditForm.validate();
        if (!valid) {
          this.$message.warning('请完善表单信息');
          return false;
        }

        let res;
        // 判断是新增还是编辑
        if (this.addOnCreditForm.id) {
          // 有id -> 编辑操作
          res = await editOnCredit(this.addOnCreditForm);
        } else {
          // 无id -> 新增操作
          res = await addOnCredit(this.addOnCreditForm);
        }

        // 统一处理响应
        if (res.code === 200) {
          this.addOnCreditDialogVisible = false;
          this.handleCloseAddOnCredit();
          await this.getOnCreditList();
          this.onCreditDialogVisible = true;
        } else {
          this.$message.error(res.message || '操作失败');
        }
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error('操作失败，请重试');
      }
    },

    //挂账类型下拉框
    async getOnCreditList() {
      const res = await getOnCreditList()
      this.onCreditOption = res.data.map(item => {
        return {
          id: item.id, label: item.name
        }
      })
    },

    handleBeforeCharge() {
      const BeforePatId = this.outpatientChargesForm.patId;
      const BeforePaidAmt = this.paymentForm.paidAmt;
      const BeforeReceiveAmt = this.paymentForm.paidAmt;
      const BeforeChange = this.paymentForm.change;
      this.handleCancelCurrentPatient();
      this.handleOutpatientYbRegisterClose();
      this.outpatientChargesForm = {
        BeforePatId: BeforePatId,
        BeforePaidAmt: BeforePaidAmt,
        BeforeReceiveAmt: BeforeReceiveAmt,
        BeforeChange: BeforeChange
      };
      this.paymentCode = '';
      this.orderId = null;
      this.settleAccountsDialogVisible = false;
      this.onCreditDialogVisible = false;
      this.payModalVisible = false;
      this.$emit('payment-complete');
    },


    async handleCashCharge() {
      await withLoading(this, '正在上传数据...')(async () => {
        // 原有的代码...
        this.paymentForm.bilgDrId = this.tableData1[0].createId;
        this.paymentForm.ids = this.tableData1.map(item => item.id);

        // 修改这行，根据动态数据判断是否有网络支付
        this.paymentForm.opeWay = 0;

        this.paymentForm.patId = this.patientChooseForm.id;
        this.paymentForm.patName = this.outpatientChargesForm.name;
        this.paymentForm.seeId = this.tableData1[0].seeDoctor;
        this.paymentForm.age = this.outpatientChargesForm.age;
        this.paymentForm.bilgDepId = this.userInfo.selDept;
        this.paymentForm.bilgDepName = this.deptOptions.find(item => item.id === this.userInfo.selDept)?.label ?? null;
        this.paymentForm.bilgDrName = this.userInfo.staffName;
        this.paymentForm.patCostType = this.outpatientChargesForm.patientType;
        this.paymentForm.regId = this.tableData1[0].registerId;
        this.paymentForm.sex = this.patientChooseForm.sex;
        this.paymentForm.clientId = this.terminalId;

        // 这里的 this.paymentForm 已经包含了动态组装的 payWay 数组
        // 可以直接调用接口
        try {
          const res = await addConfirmPayment(this.paymentForm);
          if (res.code === 200) {
            if (this.outpatientYbRegisterForm.yb_1101_ReturnInfo?.baseinfo?.psn_no !== undefined) {
              if (!(await this.handleYB_2207_Upload(res.data.id))) return;
            }

            if (this.paymentForm.opeWay === 1) {
              this.payModalVisible = true;
              this.orderId = res.data.payOrderId;
              return;
            }
            const ybSwitch = this.systemParameterList.find(item => item.name === '医保信息开关');
            if (!ybSwitch || ybSwitch.value === '1') {
              this.handleClearYbFormAfterCompletion();
            }

            // 删除这行，不再需要构建支付方式列表
            // this.paymentMethodsList = this.buildPaymentMethodsList();

            this.handleBeforeCharge();
          } else {
            this.$message.error(res.message);
          }
        } catch (error) {
          console.log(error, '支付错误');
          this.$message.error("系统异常:请联系管理员!!!");
        }
      });
    },
    handleClosePayment() {
      this.paymentForm = Object.assign({}, this.$options.data.call(this).paymentForm);
      this.settleAccountsDialogVisible = false;
    },

    //门诊收费确认结算
    async handleConfirmPayment() {
      try {
        await withLoading(this, '支付中...')(async () => {
          // 组装动态支付数据
          this.assembleDynamicPayment();

          // 计算总支付金额
          const shouldPay = Number(this.outpatientChargesForm.currentTotal) || 0;
          const totalPaid = Object.values(this.dynamicPaymentValues)
              .reduce((sum, val) => sum + (Number(val) || 0), 0);

          // 1. 验证挂账金额是否导致现金支付为负
          if (Number(this.paymentForm.bebtAmt) > Number(this.paymentForm.currentTotal)) {
            return this.$message.warning("挂账金额不能超过应收金额");
          }

          // 2. 处理挂账情况
          if (this.paymentForm.bebtAmt > 0) {
            await this.getOnCreditList();
            this.onCreditDialogVisible = true;
            return;
          }

          // 3. 验证支付金额
          if (totalPaid <= 0) {
            return this.$message.warning("请确认支付金额");
          }

          if (Math.abs(totalPaid - shouldPay) > 0.01) {
            this.$message.warning("支付金额与应收金额不匹配");
            return;
          }

          // 4. 调用支付
          await this.handleCashCharge();
        });
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },

    handleCloseOnCredit() {
      this.paymentForm.bebtId = null;
      this.$message.warning("请选择挂账类型!!!");
      this.onCreditDialogVisible = false;
    },

    //确认选择挂账类型
    handleConfirmPayment2() {
      this.paymentForm.bebtType = this.onCreditOption.find(item => item.id === this.paymentForm.bebtId).label;
      this.handleCashCharge();
    },

    //结算模态框 计算各种金额
    calculatePayments() {
      const validateAmount = (value) => {
        const num = Number(value);
        return value === '' || (!isNaN(num) && num >= 0);
      };

      const amountFields = [
        this.outpatientChargesForm.thisTimeTotal,
        this.paymentForm.chsAmt,
        this.paymentForm.bankAmt,
        this.paymentForm.bebtAmt,
        this.paymentForm.groupAmt,
        this.paymentForm.patAmt,
        this.paymentForm.distAmt
      ];

      if (!amountFields.every(validateAmount)) {
        this.$message.warning('请输入有效的正数金额');
        return;
      }

      // ===== 使用 totalChargeAmount（选中订单总金额），而不是 this.outpatientChargesForm.thisTimeTotal =====
      const total = Number(this.totalChargeAmount) || 0;

      const nonCashPaid = [
        this.paymentForm.chsAmt,
        this.paymentForm.bankAmt,
        this.paymentForm.bebtAmt,
        this.paymentForm.groupAmt,
        this.paymentForm.patAmt,
        this.paymentForm.distAmt,
      ].reduce((sum, val) => sum + (Number(val) || 0), 0);

      const cashGap = total - nonCashPaid;

      this.paymentForm = {
        ...this.paymentForm,
        cashAmt: cashGap.toFixed(2),
        recdAmt: Math.max(0, cashGap).toFixed(2),
        change: cashGap < 0 ? Math.abs(cashGap).toFixed(2) : 0.00,
        paidAmt: (nonCashPaid + Math.max(0, cashGap) - (this.paymentForm.bebtAmt ? Number(this.paymentForm.bebtAmt) : 0)).toFixed(2)
      };
    },
    async handleConfirmCharge() {
      try {
        this.chargeLoading = true;

        // 组装支付数据
        this.paymentForm.payWay = [];
        this.dynamicPaymentMethods.forEach(method => {
          const amount = Number(this.dynamicPaymentValues[method.id]) || 0;
          if (amount > 0) {
            this.paymentForm.payWay.push({
              amount: amount,
              payWayId: method.id,
              externalTradeNo: '',
              requestNo: this.generateUUID(),
              remark: ''
            });
          }
        });

        const totalPaid = Object.values(this.dynamicPaymentValues)
            .reduce((sum, val) => sum + (Number(val) || 0), 0);

        const shouldPay = this.totalChargeAmount;

        if (totalPaid <= 0) {
          this.$message.warning("请确认支付金额");
          return;
        }

        if (Math.abs(totalPaid - shouldPay) > 0.01) {
          this.$message.warning("支付金额与应收金额不匹配");
          return;
        }

        // ===== 调用整单收费接口 =====
        const requestData = {
          orderIds: this.selectedOrderIds,
          payments: this.paymentForm.payWay || [],
          remark: this.paymentForm.remarks || '',
          requestNo: this.generateRequestNo()
        };

        console.log('整单收费请求数据:', requestData);

        const res = await fullOrderCharge(requestData);

        if (res.code === 200) {
          this.$message.success('收费成功');
          this.settleAccountsDialogVisible = false;
          // 清空选中
          this.selectedOrderIds = [];
          this.selectedOrderData = [];
          this.totalChargeAmount = 0;
          this.clearRequestNo();
          // 刷新数据
          await this.loadData();
          this.tableData5 = [];
          this.showAwaitingPayDetail = false;
          this.$emit('payment-complete');
        } else {
          this.$message.error(res.message || '收费失败');
        }
      } catch (error) {
        console.error('收费失败:', error);
        this.$message.error('收费失败，请重试');
      } finally {
        this.chargeLoading = false;
      }
    },
    //打开结算模态框
    initDynamicPaymentValuesForCharge(shouldPay) {
      this.dynamicPaymentValues = {};
      this.dynamicPaymentMethods.forEach(method => {
        let defaultValue = 0;
        if (method.wayCode === 'YB' || method.wayName.includes('医保')) {
          defaultValue = this.outpatientYbRegisterForm.yb_2206_ReturnInfo?.fund_pay_sumamt || 0;
        }
        this.$set(this.dynamicPaymentValues, method.id, defaultValue);
      });
      this.calculatePayments();
    },
// 打开结算模态框
// 打开结算模态框
    async handleSettleAccounts() {
      // ===== 判断是否有选中的订单 =====
      if (this.selectedOrderIds.length === 0) {
        this.$message.warning("请先选择要收费的订单");
        return;
      }

      // ===== 使用选中订单的总金额 =====
      const shouldPay = this.totalChargeAmount;

      // ===== 从左侧表格当前选中行获取患者信息 =====
      const currentPatient = this.tableData4.find(item =>
          this.selectedOrderData.some(order => order.patientId === item.patientId)
      );

      if (!currentPatient) {
        this.$message.warning("请选择指定患者");
        return;
      }

      const patientId = currentPatient.patientId;
      const patientName = currentPatient.patientName;

      // 获取患者钱包余额
      if (patientId) {
        try {
          const balanceRes = await getAmtById(patientId);
          if (balanceRes.code === 200 && balanceRes.data) {
            this.currentRecahrgeAmt = (balanceRes.data.recahrgeAmt || 0).toFixed(2);
            this.currentHandselAmt = (balanceRes.data.handselAmt || 0).toFixed(2);
          } else {
            this.currentRecahrgeAmt = '0.00';
            this.currentHandselAmt = '0.00';
          }
        } catch (error) {
          console.error('获取钱包余额失败:', error);
          this.currentRecahrgeAmt = '0.00';
          this.currentHandselAmt = '0.00';
        }
      }

      // ===== 医保逻辑 =====
      if (Object.keys(this.outpatientYbRegisterForm.yb_1191_ReturnInfo).length > 0) {
        if (!await this.handleYBInfoUpload()) return;
      }

      if (this.outpatientYbRegisterForm.yb_2206_ReturnInfo.mdtrt_id !== undefined) {
        this.outpatientChargesForm.currentNumber = this.outpatientYbRegisterForm.yb_2206_ReturnInfo.medfee_sumamt ?? shouldPay;
        this.outpatientChargesForm.currentTotal = this.outpatientYbRegisterForm.yb_2206_ReturnInfo.medfee_sumamt ?? shouldPay;
        this.paymentForm.cashAmt =
            this.outpatientYbRegisterForm.yb_2206_ReturnInfo.medfee_sumamt - this.outpatientYbRegisterForm.yb_2206_ReturnInfo.fund_pay_sumamt -
            this.outpatientYbRegisterForm.yb_2206_ReturnInfo.acct_pay - this.outpatientYbRegisterForm.yb_2206_ReturnInfo.exp_content.wlt_acct_pay;
        this.paymentForm.chsAmt = this.outpatientYbRegisterForm.yb_2206_ReturnInfo.medfee_sumamt - this.paymentForm.cashAmt ?? null;
        this.paymentForm.recdAmt = this.outpatientYbRegisterForm.yb_2206_ReturnInfo.psn_cash_pay ?? null;
      } else {
        this.paymentForm.cashAmt = shouldPay;
        this.outpatientChargesForm.currentTotal = shouldPay;
      }

      // 查找医保信息开关
      const ybSwitch = this.systemParameterList.find(item => item.name === '医保信息开关');
      const hasReturnInfo = this.outpatientYbRegisterForm?.yb_2206_ReturnInfo?.mdtrt_id !== undefined;
      if (ybSwitch?.value === '1' && hasReturnInfo) {
        this.ybSettlementDataForm = this.outpatientYbRegisterForm.yb_2206_ReturnInfo;
        this.ybSettlementDataDialogVisible = true;
      } else {
        this.settleAccountsDialogVisible = true;
      }

      // ===== 初始化支付方式 =====
      this.initDynamicPaymentValuesForCharge(shouldPay);
      this.calculatePayments();
      this.$nextTick(() => {
        if (this.$refs.recdAmt) {
          this.$refs.recdAmt.focus();
        }
      });
    },    //单位剂量 最小剂量下拉框
    async getDosaUnt() {
      const res = await getDosaUnt();
      this.dosaUntOptions = res.data.map(item => {
        return {
          id: item.id, label: item.name
        }
      })
    },
    // ========== 生成幂等号（带缓存，用于主请求） ==========
    generateRequestNo() {
      // 如果已有缓存的幂等号，直接返回（用于重试场景）
      if (this.cachedRequestNo) {
        return this.cachedRequestNo;
      }
      // 否则生成新的UUID
      this.cachedRequestNo = this.generateUUID();
      return this.cachedRequestNo;
    },

// ========== 生成UUID（不缓存，用于子项目） ==========
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

// ========== 清除缓存的幂等号 ==========
    clearRequestNo() {
      this.cachedRequestNo = null;
    },
    //给药方式下拉框
    async getMedicationFrequency() {
      const res = await getMedicationFrequency();
      this.medicationFrequencyOptions = res.data.map(item => {
        return {
          id: item.id, label: item.name
        }
      })
    },

    //表格合计列计算
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];

      // 需要计算的字段配置
      const calcFields = {
        'purcPric': '成本',
        'salePric': '单价',
        'saleAmt': '金额',
        'cnt': '数量'
      };

      columns.forEach((column, index) => {
        // 第一列显示行号（留空）
        if (index === 0) {
          sums[index] = '';
          return;
        }

        // 第二列（剂量单位）显示"合计"文字
        if (index === 1) {
          sums[index] = '合计';
          return;
        }

        // 只处理需要计算的字段
        if (calcFields[column.property]) {
          const total = data.reduce((sum, item) => {
            const value = parseFloat(item[column.property]) || 0;
            return sum + value;
          }, 0);

          // 如果是cnt列，显示为整数，否则保留两位小数
          sums[index] = column.property === 'cnt'
              ? Math.round(total).toString()
              : total.toFixed(2);
        } else {
          // 其他列显示占位符（与图片中的"一"一致）
          sums[index] = '';
        }
      });

      return sums;
    },
    getSummaries2(param) {
      const {columns, data} = param;
      const sums = [];

      // 需要计算的字段配置
      const calcFields = {
        'pric': '执行金额',
      };

      columns.forEach((column, index) => {
        // 第一列显示行号（留空）
        if (index === 0) {
          sums[index] = '';
          return;
        }

        // 第二列（剂量单位）显示"合计"文字
        if (index === 1) {
          sums[index] = '合计';
          return;
        }

        // 只处理需要计算的字段
        if (calcFields[column.property]) {
          const total = data.reduce((sum, item) => {
            const value = parseFloat(item[column.property]) || 0;
            return sum + value;
          }, 0);

          // 如果是cnt列，显示为整数，否则保留两位小数
          sums[index] = column.property === 'cnt'
              ? Math.round(total).toString()
              : total.toFixed(2);
        } else {
          // 其他列显示占位符（与图片中的"一"一致）
          sums[index] = '';
        }
      });

      return sums;
    },

    //修改按钮
    handleEditCurrentCharge() {
      this.$message.warning('抱歉,非手工加入的项目不允许收费室修改');
    },

    //重置页面数据
    handleCancelCurrentPatient() {
      this.outpatientChargesForm = Object.assign({}, this.$options.data.call(this).outpatientChargesForm)
      this.paymentForm = Object.assign({}, this.$options.data.call(this).paymentForm);
      this.outpatientYbRegisterForm = Object.assign({}, this.$options.data.call(this).outpatientYbRegisterForm);
      this.tableData1 = [];
      this.tableData2 = [];
      this.tableData3 = [];
    },


    //项目价格下拉框
    async getChargingPrice() {
      if (this.chargingPriceOptions.length > 0) return;
      const res = await getChargingPrice();
      this.chargingPriceOptions = res.data.map(item => {
        return {
          id: item.id, label: item.costname, odcost: item.odcost,
          executedepid: item.executedepid, depexecutetype: item.depexecutetype
        }
      })
    },

    //医生下拉框
    async getDoctorList() {
      if (this.doctorOptions.length > 0) return;
      const res = await getDoctorList()
      this.doctorOptions = res.data.map(item => {
        return {id: item.id, fullName: item.fullName}
      })
    },

    //根据身份证生日
    certnoMonitor(val) {
      if (!val.certno) return;

      const idCard18Reg = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
      if (!idCard18Reg.test(val.certno)) {
        this.$message.error("身份证格式不正确");
      }

      const data = this.getAgeAndMonthsFromIdCard(val.certno);
      val.ageYear = data.years;
      val.ageMonth = data.months;
      val.brdy = val.certno.slice(6, 10) + '-' +
          val.certno.slice(10, 12) + '-' +
          val.certno.slice(12, 14)
    },

    //根据身份证出生日期
    getAgeAndMonthsFromIdCard(idCard) {
      if (!idCard || idCard.length !== 18) return {years: 0, months: 0, birthday: ''};

      const birthStr = idCard.slice(6, 14); // 格式：YYYYMMDD
      const birthday = `${birthStr.slice(0, 4)}-${birthStr.slice(4, 6)}-${birthStr.slice(6, 8)}`;

      const birthDate = new Date(birthday);
      if (isNaN(birthDate.getTime())) return {
        years: 0,
        months: 0,
        birthday: ''
      };

      // 2. 获取当前日期
      const today = new Date();

      // 3. 计算周岁
      let years = today.getFullYear() - birthDate.getFullYear();

      // 4. 计算月龄（总月数差）
      let months = (today.getFullYear() - birthDate.getFullYear()) * 12 +
          (today.getMonth() - birthDate.getMonth());

      // 5. 调整年龄和月龄（如果生日未到）
      if (
          today.getMonth() < birthDate.getMonth() ||
          (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
      ) {
        years--;
        months--;
      }

      // 6. 确保月龄为正数
      months = Math.max(0, months % 12); // 超过12个月的部分已计入周岁

      return {years, months, birthday};
    },

    //快速建档新增
    async handleAddCelerityFiling() {
      this.celerityFilingForm.tel = this.celerityFilingForm.conerTel;
      this.celerityFilingForm.restAddCode = this.handleAddressChangeCode(this.celerityFilingForm)
      this.celerityFilingForm.naplAddCode = this.handleAddressChangeCode(this.celerityFilingForm)
      console.log(this.celerityFilingForm)
      const res = await addDocphr(this.celerityFilingForm);
      if (res.code === 200) {
        this.celerityFilingDialogVisible = false;
      } else {
        this.$message.error(res.message)
      }

    },

    //转换城市代码
    handleAddressChangeCode(form) {
      const {province, city, county, town, village} = form;

      // 从村级开始逐级向上检查
      if (village && village.trim() !== '') {
        return village; // 返回村级代码
      }
      if (town && town.trim() !== '') {
        return town; // 返回乡级代码
      }
      if (county && county.trim() !== '') {
        return county; // 返回县级代码
      }
      if (city && city.trim() !== '') {
        return city; // 返回市级代码
      }
      return province || ''; // 默认返回省级（即使为空）
    },

    //科室下拉框
    async getDeptList() {
      if (this.deptOptions.length > 0) return;
      const res = await getDeptList();
      this.deptOptions = res.data.map(item => {
        return {id: item.id, label: item.deptName, specialtyName: item.specialtyName, specialtyCode: item.specialtyCode}
      })
    },

    //合约单位名称转拼音
    handleNameChangeCode(v, i) {
      switch (i) {
        case 1 :
          this.addUnitForm.pyCode =
              pinyin(this.addUnitForm.name, {pattern: 'first', toneType: 'none', separator: ''}).toLocaleUpperCase();
          break;
      }
    },

    //新增修改合约单位
    async handleAddContractUnit() {
      if (this.addUnitForm.id) {
        const res = await editContractUnit(this.addUnitForm);
        if (res.code === 200) {
          await this.getContuntList();
          this.addUnitForm = Object.assign({}, this.$options.data.call(this).addUnitForm)
          this.addUnitModalVisible = false;
        } else {
          this.$message.error("系统异常:修改合约单位失败!")
        }
      } else {
        const res = await addContractUnit(this.addUnitForm);
        if (res.code === 200) {
          await this.getContuntList();
          this.addUnitForm = Object.assign({}, this.$options.data.call(this).addUnitForm)
          this.addUnitModalVisible = false;
        } else {
          this.$message.error("系统异常:添加合约单位失败!")
        }
      }

    },

    //合约单位模态框清理
    handleCancelContract() {
      this.addUnitForm = Object.assign({}, this.$options.data.call(this).addUnitForm)
      this.addUnitModalVisible = false;
    },

    //修改合约单位
    async handleEditContractUnit(item) {
      const res = await getContractUnit(item.id.toString())
      this.addUnitForm = res.data
      this.addUnitModalVisible = true;
    },

    //患者选择表格存储选中行对象
    handleClickRow(row) {
      this.patientChooseForm = row;
    },

    // 患者选择弹窗 - 双击选择
    async handleChoosePatient() {
      if (!this.patientChooseForm || !this.patientChooseForm.id) {
        this.$message.warning('请选择一条患者记录');
        return;
      }

      await withLoading(this, '加载中...')(async () => {
        // 调用 loadData 方法传入 patientId 和 patientName
        const res = await this.loadData({
          patientId: this.patientChooseForm.id,
          patientName: this.patientChooseForm.name
        });

        // 检查是否有数据
        if (!res || res.length === 0) {
          this.$message.warning('该患者暂无待收费订单');
          // 不清空原有表格数据，只关闭弹窗
          this.loadData();
          this.patientDialogVisible = false;
          return;
        }

        // 有数据才更新患者信息
        this.outpatientChargesForm.name = this.patientChooseForm.name;
        this.outpatientChargesForm.patId = this.patientChooseForm.patId;
        this.outpatientChargesForm.age = this.getAgeAndMonthsFromIdCard(this.patientChooseForm.certno).years;
        this.outpatientChargesForm.patientType = this.patientChooseForm.prhType;
        this.outpatientChargesForm.cardId = this.patientChooseForm.patId;
        this.outpatientChargesForm.patId = '';
        this.patientDialogVisible = false;
      });
    },

    //患者搜索
    async handleSearch(row) {
      await withLoading(this, '加载中...')(async () => {
        this.patientFormDisabled = true;
        const res = await getDocphrClinicList({condtion: this.outpatientChargesForm.patId});
        if (res.data.length > 1) {
          this.patientDialogVisible = true;
          this.patientTableData = res.data;
          return;
        } else if (res.data.length <= 0) {
          this.$message.warning("没有搜索到相关患者!请在健康档案新增或点击下方快速建档!")
          this.patientFormDisabled = false;
          return;
        }
        this.patientChooseForm = res.data[0];
        console.log(this.patientChooseForm, 'this.patientChooseFormthis.patientChooseForm');
        await this.handleChoosePatient()
        this.patientFormDisabled = false;
      });
    },

    //数据字典
    async dict() {
      const res = await dict();
      this.nationOption = res.data.natyEntities.map(item => {
        return {id: item.id, label: item.name}
      })
      this.certypeOption = res.data.certypeEntities.map(item => {
        return {id: item.id, label: item.name}
      })

      this.profttlOption = res.data.profttlEntities.map(item => {
        return {id: item.id, label: item.name}
      })

      this.prhCostOption = res.data.prhCostType.map(item => {
        return {id: item.id, label: item.name}
      })

      this.prhTypeOption = res.data.prhType.map(item => {
        return {id: item.id, label: item.name}
      })

      this.rltsEntitiesOption = res.data.rltsEntities.map(item => {
        return {id: item.id, label: item.name}
      })

      this.untAtteOption = res.data.unatteVo.map(item => {
        return {id: item.id, label: item.name}
      })

      this.ntlyOptions = res.data.country.map(item => {
        return {id: item.id, label: item.name}
      })

      this.chinaMakeOptions = res.data.methodTypeVO.map(item => {
        return {id: item.id, label: item.name}
      })

      this.tcmwayOptions = res.data.tcmway.map(item => {
        return {id: item.id, label: item.name}
      })
      //账户使用标志
      this.acctUsedFlagOptions = res.data.acctUsedFlag.map(item => {
        return {id: item.codeValue, label: item.codeValueDesc}
      })
      //医疗类别
      this.medTypeOptions = res.data.medType.map(item => {
        return {id: item.codeValue, label: item.codeValueDesc}
      })
      //个人结算方式
      this.psnSetlwayOptions = res.data.psnSetlway.map(item => {
        return {id: item.codeValue, label: item.codeValueDesc}
      })

      const drugUntRes = await getDrugUnt();
      this.drugUntAndMinUnitOptions = drugUntRes.data.map(item => {
        return {
          id: item.id, label: item.name
        }
      })
      const drugDosageRes = await selectDrugDosageForm();
      this.drugDosageOptions = drugDosageRes.data.map(item => {
        return {
          id: item.id, label: item.name
        }
      })

    },

    //递级清理地域数据, 如(清空市数据,则会清空市下面所有下拉框数据(县-镇-村-乡))
    handleClear(res) {
      switch (res) {
        case 1:
          this.patientForm.province = ''
          this.patientForm.city = ''
          this.patientForm.county = ''
          this.patientForm.town = ''
          this.patientForm.village = ''
          this.villageOption = [];
          this.townOption = [];
          this.countyOption = [];
          this.cityOption = [];
          this.profttlOption = [];
          break;

        case 2:
          this.patientForm.city = ''
          this.patientForm.county = ''
          this.patientForm.town = ''
          this.patientForm.village = ''
          this.villageOption = [];
          this.townOption = [];
          this.countyOption = [];
          this.cityOption = [];
          break;
        case 3:
          this.patientForm.county = '';
          this.patientForm.town = '';
          this.patientForm.village = '';
          this.villageOption = [];
          this.townOption = [];
          this.countyOption = [];
          break;

        case 4:
          this.patientForm.town = '';
          this.patientForm.village = '';
          this.villageOption = [];
          this.townOption = [];
          break;

        case 5:
          this.patientForm.village = '';
          this.villageOption = [];
          break;
      }
    },

    //合约单位下拉框
    async getContuntList() {
      const res = await getContuntList();
      this.contractUnitOption = res.data.map(item => {
        return {id: item.id, label: item.name}
      })
    },

    //获取村
    async getVillage() {
      const areaCode = this.patientForm.town === '' ? this.celerityFilingForm.town : this.patientForm.town;
      const res = await getArea({areaCode: areaCode, areaLevel: 5, condtion: 'area_t_code'})
      this.villageOption = res.data.map(item => {
        return {
          id: item.areaCode, label: item.areaName, areaLevel: item.areaLevel
        }
      })
    },
    //获取镇
    async getTown() {
      this.patientForm.village = ''
      this.celerityFilingForm.village = ''
      const areaCode = this.patientForm.county === '' ? this.celerityFilingForm.county : this.patientForm.county;
      const res = await getArea({areaCode: areaCode, areaLevel: 4, condtion: 'area_d_code'})
      this.townOption = res.data.map(item => {
        return {
          id: item.areaCode, label: item.areaName, areaLevel: item.areaLevel
        }
      })
    },
    //获取县
    async getCounty() {
      this.patientForm.town = ''
      this.patientForm.village = ''
      this.celerityFilingForm.town = ''
      this.celerityFilingForm.village = ''
      const areaCode = this.patientForm.city === '' ? this.celerityFilingForm.city : this.patientForm.city;
      const res = await getArea({areaCode: areaCode, areaLevel: 3, condtion: 'area_c_code'})
      this.countyOption = res.data.map(item => {
        return {
          id: item.areaCode, label: item.areaName, areaLevel: item.areaLevel
        }
      })
    },
    //获取市
    async getCity() {
      this.patientForm.county = ''
      this.patientForm.town = ''
      this.patientForm.village = ''
      this.celerityFilingForm.county = ''
      this.celerityFilingForm.town = ''
      this.celerityFilingForm.village = ''
      const areaCode = this.patientForm.province === '' ? this.celerityFilingForm.province : this.patientForm.province;
      const res = await getArea({areaCode: areaCode, areaLevel: 2, condtion: 'area_p_code'})
      this.cityOption = res.data.map(item => {
        return {
          id: item.areaCode, label: item.areaName, areaLevel: item.areaLevel
        }
      })
    },
    //获取省
    async getArea() {
      this.patientForm.city = ''
      this.patientForm.county = ''
      this.patientForm.town = ''
      this.patientForm.village = ''
      this.celerityFilingForm.city = ''
      this.celerityFilingForm.county = ''
      this.celerityFilingForm.town = ''
      this.celerityFilingForm.village = ''
      const res = await getArea();
      this.provinces = res.data.map(item => {
        return {id: item.areaCode, label: item.areaName, areaLevel: item.areaLevel}
      })
    },

    //自动计算宽度
    columnWidth(col, list) {
      let prop = col.prop, lab = col.lab;
      let width = 100; // 设定一个最小值
      let maxlenStr = ""; // 最长字符串


      for (let info of list) {
        if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
      }
      width = Math.max(width, len(lab), len(maxlenStr));
      // 表格自带的内边距(20px) 自调
      return width + 8; // 这里加了 12px
      function len(str) {
        // 实际分配长度可根据需要自行调整
        let length = 12;
        for (const char of str + "") {
          // 英文小写字符 8px
          if ("a" <= char && char <= "z") length += 8;
          // 英文大写字符 8px
          else if ("A" <= char && char <= "Z") length += 8;
          // 中文字符 28px
          else if (char >= "\u4e00" && char <= "\u9fa5") length += 12;
          // 其他 8px
          else length += 12;
        }
        return length;
      }
    },

    // 实时宽度
    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 288;
    },

    //表格数据回显
    safeGetMappedValue(col, row) {
      // 1. 检查数据有效性
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';

      // 2. 检查映射数组
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;

      // 3. 执行映射
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },
    getColumnWidth(label, prop, tableData) {
      const minWidth = 80;
      const padding = 30; // 增加边距缓冲
      const contentList = tableData.map(item => item?.[prop] ?? '');

      // 计算所有内容宽度（包括表头）
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });

      return Math.max(minWidth, ...widths);
    },

    // 精确计算文本宽度（使用Canvas）
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, {column, $index}) {
      let l = column.label.length;
      let f = 12;
      column.minWidth = f * (l + 5); //加上一个文字长度
      return h("div", {class: "table-head", style: {width: "100%"}}, [
        column.label,
      ]);
    },
    getRandom4Digits() {
      return Math.floor(1000 + Math.random() * 9000).toString();
    },
  }
}
</script>


<style lang="less" scoped>
.selected-summary {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 15px;
  background: #ffffff;
  border-top: 1px solid #e8ecf1;
  gap: 15px;
  font-size: 13px;
  height: 56px;
  box-sizing: border-box;
}
/* 隐藏 number 输入框的箭头（Chrome / Safari / Edge） */
/deep/ .el-input input[type="number"]::-webkit-outer-spin-button,
/deep/ .el-input input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* 隐藏 Firefox 的箭头 */
/deep/ .el-input input[type="number"] {
  -moz-appearance: textfield;
}

/* “分配”按钮样式 */
.assign-btn {
  cursor: pointer;
  color: #409eff;
  font-size: 12px;
  line-height: 28px;
  margin-right: 5px;
  user-select: none;
}
.assign-btn:hover {
  color: #66b1ff;
}
.flex-form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 10px;
}

.form-item-flex {
  flex: 0 0 auto;
  margin-bottom: 0;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .flex-form-row {
    gap: 12px;
  }
}

@media (max-width: 768px) {
  .flex-form-row {
    gap: 8px;
  }
}

/* 基础样式 */
.settle-form {
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.form-section {
  margin-bottom: 20px;
  padding: 5px;
  border-radius: 4px;
  background-color: #f9f9f9;
  border: 1px solid #ebeef5;
}

.section-title {
  font-weight: bold;
  margin-bottom: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
  color: #333;
  font-size: 14px;
}

/* 各模块特殊样式 */
.basic-section {
  background-color: #f5f7fa;
  border-left: 4px solid #909399;
}

.registration-section {
  background-color: #f0f9eb;
  border-left: 4px solid #67c23a;
}

.payment-section {
  background-color: #ecf5ff;
  border-left: 4px solid #409eff;
}

.remark-section {
  background-color: #fdf6ec;
  border-left: 4px solid #e6a23c;
}

/* 操作按钮样式 */
.form-actions {
  text-align: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px dashed #ddd;
}

/* 基本信息行样式 */
.basic-info-row {
  margin-bottom: 15px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .el-col {
    margin-bottom: 10px;
  }
}

.card-title {
  font-size: 16px;
  font-weight: bold;
}

.box-card {
  margin-bottom: 20px;
}

/* 地址选择器容器样式 */
.address-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

/* 地址单位标签样式 */
.address-unit {
  margin: 0 5px;
  color: #909399;
  font-size: 12px;
}

/* 紧凑表单样式 */
.compact-form .el-form-item {
  margin-bottom: 12px;
}

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 半透明遮罩 */
}

.el-icon-loading {
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.payment-form {
  background: #f5f5f5;
  border-radius: 4px;
}

.form-header {
  background: #409EFF;
  color: white;
  padding: 10px 15px;
  margin: -20px -20px 20px -20px;
  border-radius: 4px 4px 0 0;
  font-size: 16px;
  font-weight: bold;
}

.form-section {
  background: white;
  margin-bottom: 15px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.payment-summary {
  background: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
  margin-top: 15px;
}

.amount {
  color: #f56c6c;
  font-weight: bold;
  display: inline-block;
  width: 120px;
  text-align: left;
}

.form-actions {
  text-align: center;
  margin-top: 20px;
}


.el-table__footer-wrapper {
  position: sticky !important;
  bottom: 0;
  background: white;
  z-index: 10;
  display: table-footer-group !important;
}

/* 调整滚动区域 */
.el-table__body-wrapper {
  max-height: calc(55vh - 48px) !important;
  overflow-y: auto !important;
}

.custom-summary-table {
  overflow: visible !important;
}

/* 将合计行固定在表格数据下方（不受滚动条影响） */
.custom-summary-table .el-table__footer-wrapper {
  position: sticky !important;
  bottom: 0;
  background: white;
  z-index: 10;
  border-top: 1px solid #ebeef5; /* 可选：添加分隔线 */
}

/* 调整表格内滚动区域高度 */
.custom-summary-table .el-table__body-wrapper {
  max-height: calc(55vh - 48px); /* 减去合计行高度 */
  overflow-y: auto !important;
}

/* 全局样式或组件内样式 */
.el-table__footer {
  background-color: white !important; /* 改为白色背景 */
  border-top: 1px solid #EBEEF5; /* 保留顶部边框线 */
}

.el-table__footer .el-table__cell {
  background-color: inherit !important; /* 继承白色背景 */
}

/* 调整文字样式（可选） */
.el-table__footer .cell {
  color: #606266; /* 默认文字颜色 */
  font-weight: normal; /* 取消加粗 */
}

.medical-system-container {
  display: flex;
  flex-direction: column;
  height: 65vh;
  width: 100%;
  overflow: hidden;
  position: relative;
}

/* 主表格区域 */
.table-main-container {
  display: flex;
  flex: 1;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

/* 左表格 - 默认铺满 */
.table-left {
  flex: 1;
  height: 100%;
  overflow: auto;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

/* 右抽屉表格 - 初始隐藏 */
.table-drawer {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 0;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  z-index: 10;
  overflow: hidden;
}

/* 抽屉打开状态 */
.table-drawer.open {
  width: 50%; /* 可根据需要调整宽度 */
  min-width: 400px; /* 最小宽度 */
}

.drawer-content {
  height: 100%;
  width: 100%;
  overflow: auto;
  box-sizing: border-box;
}

/* 当抽屉打开时，左表格缩进 */
.table-main-container.with-drawer .table-left {
  margin-right: 50%; /* 与抽屉宽度一致 */
}

/* 底部控制表单 - 固定在底部 */
.bottom-control-form {
  padding: 10px;
  background: #f5f7fa;
  border-top: 1px solid #e6e6e6;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.05);
}

.form-grid {
  display: flex;
  flex-direction: column;
}


/* 按钮组布局 */
.button-group {
  display: flex;
  justify-content: space-between;
}

.primary-actions {
  display: flex;
  gap: 10px;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

/* 表格样式增强 */
.el-table {
  height: 100%;
}

.el-table th {
  background-color: #f8f8f9;
  font-weight: 600;
}

.el-table--border {
  border: 1px solid #ebeef5;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .table-drawer.open {
    width: 50%;
    min-width: 350px;
  }

  .table-main-container.with-drawer .table-left {
    margin-right: 50%;
  }
}

.form-grid {
  display: flex;
  flex-direction: column;
}

.form-main {
  margin-bottom: 70px;
}

.button-group {
  display: flex;
  justify-content: space-between;
}

.primary-actions,
.action-buttons {
  display: flex;
  gap: 8px;
}


.button-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.action-buttons {
  display: flex;
  gap: 10px; /* 按钮间距 */
}


/* 新增底部输入盒子样式 */
.bottom-input-box {
  padding: 15px;
  background: #f8f8f9;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
}


/deep/ .el-dialog__header {
  padding: 18px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

.dialog {
  .addUnitDialog {
    .tabs {
      /deep/ .el-select > .el-input {
        width: 172px;
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 172px;
      }

      /deep/ .el-form-item__content {
        display: flex;

        span {
          font-size: 12px;
        }
      }

      .oneLine {
        width: 524px;
        // background-color: indianred;
      }
    }

    /deep/ .el-dialog__title {
      font-size: 15px;
    }

    /deep/ .el-table {
      font-size: 15px;
    }
  }

  .patient-dialog {
    .tabs {
      /deep/ .el-select > .el-input {
        width: 172px;
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 172px;
      }

      /deep/ .el-form-item__content {
        display: flex;

        span {
          font-size: 12px;
        }
      }

      .oneLine {
        width: 524px;
        // background-color: indianred;
      }
    }

    /deep/ .el-dialog__title {
      font-size: 15px;
    }

    /deep/ .el-table {
      font-size: 15px;
    }
  }
}


/* Vue 2 深度选择器写法 */
.custom-table /deep/ .el-table--border {
  border: 1px solid #e6e6e6;
}

.custom-table /deep/ .el-table__header th,
.custom-table /deep/ .el-table__body td {
  border-right: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}

.custom-table /deep/ .el-table__header th {
  background-color: #f5f7fa; /* 表头背景色 */
}

.data-row {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
}

.label {
  width: 70px;
  font-size: 13px;
}

.el-input {
  flex: 1;
}


.side-panel {
  width: 240px;
  padding: 10px;
  background: #f5f7fa;
}

.registration-box {
  background: white;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.data-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.label {
  width: 70px;
  font-size: 13px;
  color: #ffffff;
  margin-right: 4px;
}

.el-input {
  flex: 1;
}

.el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5;
  color: #666;
}

/* 新增样式 */
.register-group {
  width: 50%;
  display: flex;
  gap: 16px;
  margin-top: 8px;
}

/* 调整原有分隔线位置 */
.divider-line {
  width: 100%;
  margin: 12px 0 8px;
}

/* 强制同行显示 */
.register-type + .clinic-room {
  margin-left: -8px; /* 补偿间距 */
}

/* 关键修复样式 */
.compact-form {
  /* 在原有样式基础上添加 */

  .register-type,
  .clinic-room {
    flex: 1; /* 平分剩余空间 */
    min-width: 240px; /* 最小宽度保证换行后对齐 */
    max-width: 50%; /* 最大不超过50% */

    /deep/ .el-form-item__content {
      width: calc(100% - 90px) !important; /* 匹配label宽度 */
    }
  }

  /* 强制同行显示 */

  .register-type + .clinic-room {
    margin-left: -8px; /* 补偿间距 */
  }

  /deep/ .el-form-item__content {
    margin-left: 0 !important; /* 消除ElementUI默认的左侧间距 */
    width: auto !important; /* 取消固定宽度 */
  }

  /deep/ .el-form-item__label {
    padding-right: 6px !important; /* 标签与输入框间距 */
    width: auto !important; /* 取消标签固定宽度 */
    flex: none !important; /* 禁用flex自动分配 */
  }

  .el-form-item {
    /* 调整整体间距 */
    gap: 4px; /* 标签与控件间距 */
    margin-bottom: 15px;
    /* 微调对齐方式 */
    align-items: baseline;
  }

  /* 特殊处理复选框 */

  .el-checkbox {
    margin-left: 2px;

    /deep/ .el-checkbox__label {
      display: none; /* 隐藏默认标签 */
    }
  }

  /* 输入框尺寸补偿 */

  .el-input--mini {
    line-height: 28px;

    /deep/ .el-input__inner {
      padding: 0 8px;
    }
  }
}

.compact-form-box {
  height: auto !important; /* 改为自适应高度 */
  padding: 12px 8px; /* 调整内边距 */
}

.compact-form {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px; /* 行列间距 */

  .el-form-item {
    margin: 0;
    display: inline-flex;
    align-items: center;

    /* 标签对齐 */

    /deep/ .el-form-item__label {
      line-height: 28px;
      padding-right: 4px;
    }

    /* 表单控件通用样式 */

    .el-input,
    .el-select,
    .el-date-editor {
      width: 100px; /* 默认宽度 */
    }

    /* 特定字段宽度调整 */

    &[label="性别:"] .el-select {
      width: 70px;
    }


    &[label="职业:"] .el-select {
      width: 130px;
    }

    &[label="病员费别:"] .el-select,
    &[label="病员类型:"] .el-select {
      width: 135px;
    }

    &[label="联系电话:"] .el-input {
      width: 135px;
    }


    &[label="挂号类别:"] .el-select,
    &[label="诊室:"] .el-select {
      width: 300px;
    }

    /* 地址输入组 */

    .age-select-address {
      display: flex;
      align-items: center;
      gap: 4px;

      .el-input {
        width: 60px !important;

        &:nth-last-child(2) {
          width: 150px !important;
        }

        /* 乡镇输入框 */
      }
    }
  }

  /* 分隔线样式 */

  .divider-line {
    width: 100%;
    margin: 20px 10px 0;
    border-top: 1px solid #ebeef5;
  }
}


.divider-line {
  height: 1px;
  background-color: #ebeef5;
  margin: 15px 10px 0;
}

.compact-form-box {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 6px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.compact-form {
  font-size: 12px;
}

.el-form-item {
  margin-bottom: 5px;
}

.age-unit {
  margin: 0 5px;
  color: #ffffff;
  font-size: 12px;
}

.MedicenCata {
  height: 100%;
  width: 100%;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    .header-icon {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }

}
</style>